import { Formik, useFormikContext } from "formik";
import React, { useEffect, useRef, useState } from "react";
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import { Alert } from "@mui/material";
import { Helmet } from "react-helmet";
import { GridSortModel } from '@mui/x-data-grid-pro';
import { CodesEditDialog, Loadable, NotesDialog, NoteType, PopoverLink } from '../../../common';
import { DetailsPopover } from '../../../common/detailsPopover';
import { renderErrorMessage } from '../../../util/error';
import { commaSeparatedPattern } from '../../../util/validation';
import { toLocalStorage } from '../../../util/storage';
// eslint-disable-next-line no-restricted-imports
import Card from 'react-bootstrap/Card';
import { useHistory, useLocation } from 'react-router-dom';
import DeleteIcon from '@mui/icons-material/Delete';
// eslint-disable-next-line no-restricted-imports
import CircularProgress from '@mui/material/CircularProgress';
import ZoomInIcon from '@mui/icons-material/ZoomIn';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import {
  Portlet,
  PortletBody,
  PortletHeader,
  PortletHeaderToolbar
} from "../../../partials/content/Portlet";

import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  FormControl,
  FormControlLabel,
  FormHelperText,
  FormLabel,
  Grid,
  IconButton,
  Input,
  InputAdornment,
  InputLabel,
  MenuItem,
  Radio,
  RadioGroup,
  Select,
  Switch,
  TextField,
  TextareaAutosize,
  Typography,
  FormGroup,
  Tooltip
} from "@mui/material";

import makeStyles from '@mui/styles/makeStyles';

import { Autocomplete } from '@mui/material';
import RuleMultiPrecidenceFieldArray from './RuleMultiPrecidenceFieldArray';

import BackButton from "../../../common/BackButton/BackButton.js";
import { SplitButton } from "../../../common/splitButton";
import { UnsavedChangesDialog } from './UnsavedChangesDialog';
import { CONTRACTED_SERVICE_INPATIENT, CONTRACTED_SERVICE_OUTPATIENT, CONTRACTED_SERVICE_PROFESSIONAL, MODIFIER_PAY_METHOD_MULTI_PROCEDURE, PAY_METHOD_2ND_DOLLAR, PAY_METHOD_ANESTHESIA, PAY_METHOD_CASE_RATE, PAY_METHOD_PER_DIEM, PAY_METHOD_PER_DIEM_STOP_LOSS, PAY_METHOD_PER_UNIT, PAY_METHOD_PERCENTAGE, PAY_METHOD_STOP_LOSS, PAY_SOURCE_CHARGE, PAY_SOURCE_SCHEDULE, RULE_APPLY_AT_DATE_OF_SERVICE } from '../../../store/constants/contract';
import { FeeScheduleSelection } from "../../feeSchedulePage/feeScheduleSelectionComponent";
import GlobalFeeScheduleFields from "./GlobalFeeScheduleFields";
import { checkRequiresGlobalConfig, validateRegionalFields, hasRegionalFieldErrors } from '../../../store/api/globalFeeSchedule';
import { RuleNPIRoleFieldArray } from "./NPIRoleFieldArray";
import RuleModifierFieldArray from "./RuleModifierFieldArray";
import RuleNPIRateFieldArray from "./RuleNPIRateFieldArray";
import RuleSelectionCriteriaFieldArray from "./RuleSelectionCriteriaFieldArray";
import SomeTimesPayCodes from "./subConfigurations/SomeTimesPayCodes.js";
import RulesSplitFieldArray from "./RulesSplitArray";
import RulePaymentFeeScheduleArray from "./RulePaymentFeeScheduleArray";
import RuleFeeScheduleGroupArray from "./RuleFeeScheduleGroupArray";
import DrgWatcher from "./DrgWatcher";
import RuleLesserOfFieldArray from "./RuleLesserOfFieldArray";
import RuleProviderRolePaymentGroupFieldArray from "./ProviderRolePaymentFieldArray/RuleProviderRolePaymentGroupFieldArray";
import EntityAuditLogsDialog from "../../TrailLogsPage/EntityAuditLogsDialog";
import { toast } from "react-toastify";

const useStyles = makeStyles(theme => ({
  root: {
    flexGrow: 1,
  },
  button: {
    margin: theme.spacing(1),
  },
  textService: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
    width: '45%'
  },
  textField: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
    width: '90%'
  },
  textFieldInline: {
    marginTop: theme.spacing(3),
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
    width: '90%'
  },
  formControl: {
    marginLeft: theme.spacing(1),
    width: '90%',
    marginTop: theme.spacing(2),
  },
  formControl1: {
    marginLeft: theme.spacing(5),
    width: '90%',
    marginTop: theme.spacing(1),
    maxWidth: '300px',
  },
  formToggle: {
    marginLeft: theme.spacing(1),
    width: '90%',
    marginTop: theme.spacing(4),
  },
  formToggleCard: {
    marginLeft: theme.spacing(1),
    width: '90%',
  },
  textArea: {
    marginLeft: theme.spacing(1),
    width: '95%',
  },
  ruleGroups: {
    maxHeight: '65vh',
    overflow: 'auto',
  },
  switchFormControl: {
    marginLeft: 0,
    marginTop: theme.spacing(3)
  },
  helpIcon: {
    color: 'red',
    padding: 0,
    minWidth: 'auto',
  },
  list: {
    marginTop: theme.spacing(3),
  },
  codesLabel: {
    marginLeft: theme.spacing(1),
    marginTop: 19,
    fontSize: '0.8rem',
    marginBottom: 6
  },
  textareaAutosize: {
    marginLeft: theme.spacing(1),
    width: '95%',
    borderTop: 'none',
    borderLeft: 'none',
    borderRight: 'none',
    outline: 'none',
    '&:focus': {
      borderTop: 'none',
      borderLeft: 'none',
      borderRight: 'none',
    },
    '&:focus-visible': {
      borderTop: 'none',
      borderLeft: 'none',
      borderRight: 'none',
    }
  },
  errorColor: {
    color: '#fd397a',
  },
  helperText: {
    marginLeft: '8px'
  },
  textAreaError: {
    borderColor: '#fd397a',
    borderWidth: '2px',
  },
  helpClass: {
    position: 'relative',
    top: 10,
    marginLeft: -12,
    pointerEvents:"auto"
  },
  feeScheduleLabel: {
    marginTop: '-30px',
    marginLeft:'5px',
    fontSize:'11px'
  },
  criteriaORLabel: {
    marginTop: '3px'
  },
  criteriaToggle: {
    marginBottom: '0 !important'
  },
  autoComplete: {
    marginLeft: theme.spacing(5),
    width: '90%',
    maxWidth: '300px',
  },
  viewOnly:{
    pointerEvents:"none",
    opacity:0.8
  },
    prevNextButtons: {
        color: '#72777f',
        textTransform: 'none',
        '& .MuiButton-startIcon': { marginRight: '0px !important' },
        '& .MuiButton-endIcon': { marginLeft: '0px !important' },
    },
}));
const multiLevelHierarchy=['Claim Analysis', 'Charge Analysis', 'Summary Dashboard', 'Confidence Score Triage']
const validPayMethodsInSplitCase=[
  'Per Unit',
  'Per Diem',
  'Flat Rate'
]

export default function RulesEditPage({
  intl, initialValues, rulesGetPending, ruleId, ruleTypes, methodTypes, feeSchedules, history,
  rulesCreatePending, rulesUpdatePending, mode, serviceId, payMethods, selectedServerGroups = [],
  contractId, serviceType, codeServices, codeServicesTinyPending, paySources, multiprocPrecedences, contract, rulesList,
  rulesValidateCodesPending, rulesValidateCodesError, rulesValidateCodesErrorMessage, modifiers, modifiersPayMethods,
  ruleCriteria, feeScheduleLabels, isRateExist, getFeescheduleRateLabelPending, getFeescheduleLabelsPending,directoryId, isViewOnly,paySplit,
  npiRoles, dischargeStatusCodes, def_rulePaymentFeeScheduleXRef, isFeeScheduleDrgData, isCodeServiceDrgData, canAccessCMS, providerRoleCriteria,getFeeScheduleItemsPending, grouperConfigs,
  notes, notesCount, notesListPending, notesSavePending, notesExportPending,
  notesSaveError, notesSaveErrorMessage,
  actions: {
    ruleGet, ruleCreate, ruleUpdate, ruleErrorReset, ruleGetMethodTypes, ruleGetPayMethods, getContract,
    ruleGetTypes, contractFeeScheduleList, codeServicesListTiny, ruleGetPaySources, ruleGetMultiPrecedences,
    ruleCodesValidate, getModifiers, getModifiersPayMethods, getRuleCriteria, resetCodesValidate, getFeeScheduleLabels,
    getFeescheduleRateLabel, getNpiRoles, getDischargeStatusCodes, getFeeSchedule, isFeeScheduleDrg, isCodeServiceDrg, getProviderRoleCriteria,
    getGrouperConfigs, setGlobalConfigsFilters, getNotes, createNote, exportNotes, contractRulesList: _contractRulesList
  }
}) {
    const NOTES_PAGE_SIZE = 10;
    const routesHistory = useHistory();

  const classes = useStyles();
  const isEdit = mode === 'edit';
  const isCopyRule = window.location.pathname.includes('/copy/');
  const [selectedGroups, setSelectedGroups] = useState([]);
  const [shouldReset, setShouldReset] = useState(false);
  const [searchAction, setSearchAction] = useState('Search');
  const [isWarnOpen, setWarnOpen] = useState(false);
  const formikRef = useRef<any>();
  const [isCodesOpen, setCodeOpen] = useState(false);
  const [selectedFeeScheduleLabelRates, setSelectedFeeScheduleLabelRates] = useState([]);
  const breadCrumbsHierarchy:any=document.getElementsByClassName('MuiBreadcrumbs-li') ;
  const [viewOnly, setViewOnly] = useState(isViewOnly ?  true:false);
  const [isSplitPayments, setIsSplitPayments] = useState(false);
  const [totalPaymentsSplit, setTotalPaymentsSplit] = useState(1);
  const [isDrgCodeSelectionType, setIsDrgCodeSelectionType] = useState(false);
  let arrayPush = null;

  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);
  const [isPopoverOpen, setIsPopoverOpen] = useState(false);
  const [hoverFeeSchedule, setHoverFeeSchedule] = useState<any>(null);
  const [hoverFeeScheduleId, setHoverFeeScheduleId] = useState<number | null>(null);
  const [hoverFeeScheduleRegionalFilters, setHoverFeeScheduleRegionalFilters] = useState<{ state?: string | null, gpci?: string | null, locality?: string | null } | null>(null);
  const [showCodeSelectionGlobalConfig, setShowCodeSelectionGlobalConfig] = useState(false);
  const [isInvalidForm, setIsInvalidForm] = useState(false);
  const [notesOpen, setNotesOpen] = useState(false);
  const [notesPage, setNotesPage] = useState(0);
  const DEFAULT_NOTES_SORT: GridSortModel = [{ field: 'createdAt', sort: 'desc' }];
  const toBackendNotesSort = (model: GridSortModel = DEFAULT_NOTES_SORT) => {
    const normalized = model.filter((x) => x.sort === 'asc' || x.sort === 'desc');
    const source = normalized.length > 0 ? normalized : DEFAULT_NOTES_SORT;
    return source.map((x) => ({ id: x.field, direction: x.sort as 'asc' | 'desc' }));
  };
  const [notesSortModel, setNotesSortModel] = useState<GridSortModel>(DEFAULT_NOTES_SORT);
  const previousNotesSavePending = useRef(false);
  const [auditLogsOpen, setAuditLogsOpen] = useState(false);

  let currentIndex = -1;
  let prevRuleId = null;
  let nextRuleId = null;

  if (rulesList && ruleId) {
    currentIndex = rulesList.findIndex(r => String(r.id) === String(ruleId));
    if (currentIndex > 0) prevRuleId = rulesList[currentIndex - 1]?.id;
    if (currentIndex >= 0 && currentIndex < rulesList.length - 1) nextRuleId = rulesList[currentIndex + 1]?.id;
  }

  const [unsavedChangesModal, setUnsavedChangesModal] = useState<{ open: boolean, type: 'Next' | 'Prev' | null }>({ open: false, type: null });


  // State to track rate label validation errors by index
  const [rateLabelValidationErrors, setRateLabelValidationErrors] = useState<Record<number, boolean>>({});
  const [rateLabelValidationLesserOfErrors, setRateLabelValidationLesserOfErrors] = useState<Record<number, boolean>>({});
  const [rateLabelValidationProviderRoleErrors, setRateLabelValidationProviderRoleErrors] = useState<Record<number, boolean>>({});
  
  // Safe wrapper for setShowCodeSelectionGlobalConfig to prevent corruption
  const safeSetShowCodeSelectionGlobalConfig = (value: any) => {
    const boolValue = Boolean(value);
    setShowCodeSelectionGlobalConfig(boolValue);
  };
  
  // Initialize showCodeSelectionGlobalConfig for edit mode (run only once)
  const globalConfigInitializedRef = React.useRef(false);
  // Track which fee schedules have already been fetched to prevent duplicate calls
  const fetchedFeeSchedulesRef = useRef(new Set());

  useEffect(() => {
    if (mode === 'edit' && initialValues && initialValues.globalFeeScheduleId && initialValues.codeSelectionType === 'Fee Schedule' && !globalConfigInitializedRef.current) {

      globalConfigInitializedRef.current = true;
      // In edit mode with globalFeeScheduleId, check if regional fields have data (meaning it's RBRVS)
      // If all regional fields are null, it's a CLAB schedule - don't show config fields
      const hasRegionalData = initialValues.globalFeeScheduleState || 
                              initialValues.globalFeeScheduleLocality || 
                              initialValues.globalFeeScheduleGPCI ||
                              initialValues.selectedState ||
                              initialValues.selectedLocality ||
                              initialValues.selectedGpci;
      safeSetShowCodeSelectionGlobalConfig(Boolean(hasRegionalData));
    }
  }, [mode, initialValues, safeSetShowCodeSelectionGlobalConfig]);

  const filteredPayMethods = payMethods?.filter(payMethod => {
    if (payMethod.name === PAY_METHOD_PER_DIEM_STOP_LOSS) {
      return serviceType === CONTRACTED_SERVICE_INPATIENT;
    }
    if (payMethod.name === PAY_METHOD_PER_UNIT) {
      return false;
    }
    return true;
  }) || [];

 const handleCallback = (savedRuleId, criteriaCount) => {
    if (mode === 'create') {
      toLocalStorage('pendingRuleReorder', {
        action: 'create',
        serviceId: Number(serviceId),
        criteriaCount: criteriaCount || 0
      });
    } else if (mode === 'edit' && savedRuleId) {
      toLocalStorage('pendingRuleReorder', {
        action: 'edit',
        ruleId: savedRuleId,
        serviceId: Number(serviceId),
        criteriaCount: criteriaCount || 0
      });
    }

    if (searchAction === 'Next' && nextRuleId) {
      routesHistory.replace(`/cms/contract/${contractId}/rule/${serviceId}/edit/${nextRuleId}/${directoryId || 'root'}`);
    } else if (searchAction === 'Prev' && prevRuleId) {
      routesHistory.replace(`/cms/contract/${contractId}/rule/${serviceId}/edit/${prevRuleId}/${directoryId || 'root'}`);
    } else {
      history.push(`/cms/contract/view/${contractId}${multiLevelHierarchy.includes(breadCrumbsHierarchy[0]?.innerText)===false ? `/${directoryId || 'root'}` : ''}`);
    }
  }

  // Simple date formatter for Fee Schedule popover
  const formatDate = (dateString: string | Date, format?: string): string => {
    if (!dateString) return '';
    const date = typeof dateString === 'string' ? new Date(dateString) : dateString;

    if (format === 'YYYY-MM-DD') {
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      return `${year}-${month}-${day}`;
    }

    // Default format: M/D/YYYY
    return `${date.getMonth() + 1}/${date.getDate()}/${date.getFullYear()}`;
  };

  function handleHoverFeeSchedule(element: HTMLElement, feeScheduleId?: number | null, feeScheduleData?: any, isGlobal=false, regionalFilters?: { state?: string | null, gpci?: string | null, locality?: string | null } | null) {
    if (!feeScheduleId || document.querySelector('.MuiDialog-root')) return;
    
    const savedPages = JSON.parse(sessionStorage.getItem('pages') || '{}');
    delete savedPages['global-feeschedule-items-landing'];
    sessionStorage.setItem('pages', JSON.stringify(savedPages));
    
    setAnchorEl(element);
    setHoverFeeScheduleId(feeScheduleId);
    setIsPopoverOpen(true);
    setHoverFeeScheduleRegionalFilters(regionalFilters || null);

    if (feeScheduleData && feeScheduleData?.id==feeScheduleId) {
      setHoverFeeSchedule(isGlobal ? {...(feeScheduleData || {}),global:true} : feeScheduleData);
    } else {
      getFeeSchedule(feeScheduleId, (fs: any) => {
        setHoverFeeSchedule({...(fs || {}),global:isGlobal ? true:false});
      },isGlobal ? true:false);
    }
  }

  function popoverLeave() {
    setIsPopoverOpen(false);
  }

  function paperEnter() {
    setIsPopoverOpen(true);
  }

  useEffect(() => {
    getRuleCriteria();
  }, [getRuleCriteria]);

  useEffect(() => {
    getProviderRoleCriteria();
  }, [getProviderRoleCriteria]);

  useEffect(() => {
    getModifiersPayMethods();
  }, [getModifiersPayMethods])

  useEffect(() => {
    getModifiers();
  }, [getModifiers])

  useEffect(() => {
    setSelectedGroups(selectedServerGroups);
  }, [selectedServerGroups]);

  useEffect(() => {
    if (contract === undefined) {
      getContract(contractId)
    }
  }, [contract, getContract]);

  useEffect(() => {
    getNpiRoles();
  }, [getNpiRoles]);

  useEffect(() => {
    getDischargeStatusCodes();
  }, []);

  // On direct page-load / reload, if rulesList is empty fetch them so Next/Previous work
  useEffect(() => {
    if (isEdit && (!rulesList || rulesList.length === 0)) {
      _contractRulesList(serviceId);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isEdit, serviceId]);

  const renderValidationMessage = () => {
    return renderErrorMessage(rulesValidateCodesError, rulesValidateCodesErrorMessage);
  }

  const ruleTypesCallback = (rTypes) => {
    if (rTypes && rTypes.length > 0 && !isEdit) {
      const ruleType = rTypes.find(x => x.name === 'RULE');
      if (ruleType) {
        if (formikRef.current) {
          formikRef.current.setFieldValue('ruleTypeId', ruleType.id);
        }
      }
    }
  }
  useEffect(() => {
    const breadCrumbsText =
        document.getElementsByClassName("breadcrumb-active")[0];
    if (viewOnly) {
        breadCrumbsText.innerHTML = "View Rule";
    } else if (isCopyRule) {
      breadCrumbsText.innerHTML = "Copy Rule";
    } else {
      breadCrumbsText.innerHTML =!isEdit ? "Add Rule": "Edit Rule";
    }
}, [viewOnly]);

  useEffect(() => {
    ruleGetMethodTypes();
    ruleGetTypes(ruleTypesCallback);
    ruleGetPayMethods();
    contractFeeScheduleList();
    codeServicesListTiny();
    ruleGetPaySources();
    ruleGetMultiPrecedences();
    getGrouperConfigs();
  }, [ruleGetMethodTypes, ruleGetTypes, ruleGetPayMethods,
    contractFeeScheduleList, codeServicesListTiny, ruleGetPaySources, ruleGetMultiPrecedences
  ]);

  useEffect(() => {
    if (mode === 'edit') {
      ruleGet(ruleId);
    }
  }, [mode, ruleGet, ruleId]);

  useEffect(() => {
    if (mode === 'edit') {
      getNotes(
        NoteType.Rule,
        1,
        NOTES_PAGE_SIZE,
        ruleId,
        toBackendNotesSort(DEFAULT_NOTES_SORT),
      );
    }
  }, [mode, getNotes, ruleId]);

  useEffect(() => {
    if (previousNotesSavePending.current && !notesSavePending) {
      if (!notesSaveError) {
        toast.success("Note saved successfully.", {
          autoClose: 3000,
        });
      }}
    previousNotesSavePending.current = notesSavePending;
  }, [notesSavePending]);

  useEffect(() => {
    if (initialValues && mode === 'edit') {
      const isGlobal = initialValues.useGlobalFeeSchedules || false;
      const useSplitPayment = initialValues.useSplitPayment || false;

      if (useSplitPayment) {
        if (initialValues.ruleSplitPaymentXref && initialValues.ruleSplitPaymentXref.length > 0) {
          const splitEntries = initialValues.ruleSplitPaymentXref;
          splitEntries.forEach((entry, index) => {
            const feeScheduleId = isGlobal ? entry.globalFeeScheduleId : entry.feeScheduleId;
            const fetchKey = `split-${feeScheduleId}-${isGlobal}`;

            if (feeScheduleId && !fetchedFeeSchedulesRef.current.has(fetchKey)) {
              fetchedFeeSchedulesRef.current.add(fetchKey);
              const rateLabelCallback = (newFeeScheduleLabels) => {
                if (formikRef.current) {
                  const hasTouched = Object.keys(formikRef.current.touched).length > 0;
                  if (!hasTouched) {
                    const newValues = JSON.parse(JSON.stringify(formikRef.current.values));
                    newValues.ruleSplitPaymentXref[index].rateLabels = newFeeScheduleLabels;
                    formikRef.current.resetForm({ values: newValues, initialValues: newValues });
                  } else {
                    formikRef.current.setFieldValue(`ruleSplitPaymentXref[${index}].rateLabels`, newFeeScheduleLabels);
                  }
                }
              };
              getFeeScheduleLabels(feeScheduleId, rateLabelCallback, null, null, isGlobal);
            }
          });
        }
      } else {
        if (initialValues.rulePaymentFeeScheduleXRef && initialValues.rulePaymentFeeScheduleXRef.length > 0) {
          const entries = initialValues.rulePaymentFeeScheduleXRef;
          entries.forEach((entry, index) => {
            const feeScheduleId = isGlobal ? entry.globalFeeScheduleId : entry.feeScheduleId;
            const fetchKey = `payment-${feeScheduleId}-${isGlobal}`;

            if (feeScheduleId && !fetchedFeeSchedulesRef.current.has(fetchKey)) {
              fetchedFeeSchedulesRef.current.add(fetchKey);
              const rateLabelCallback = (newFeeScheduleLabels) => {
                if (formikRef.current) {
                  const hasTouched = Object.keys(formikRef.current.touched).length > 0;
                  if (!hasTouched) {
                    const newValues = JSON.parse(JSON.stringify(formikRef.current.values));
                    newValues.rulePaymentFeeScheduleXRef[index].rateLabels = newFeeScheduleLabels;
                    formikRef.current.resetForm({ values: newValues, initialValues: newValues });
                  } else {
                    formikRef.current.setFieldValue(`rulePaymentFeeScheduleXRef[${index}].rateLabels`, newFeeScheduleLabels);
                  }
                }
              };
              getFeeScheduleLabels(feeScheduleId, rateLabelCallback, null, null, isGlobal);
            }
          });
        }
      }

      // SS02-616: Handle fee schedule groups (Schedule pay source)
      if (initialValues.ruleFeeScheduleGroupXref && initialValues.ruleFeeScheduleGroupXref.length > 0) {
        const groups = initialValues.ruleFeeScheduleGroupXref;
        groups.forEach((group, groupIndex) => {
          // Determine which fee schedule ID to use based on global/local toggle
          const feeScheduleId = isGlobal ? group.globalFeeScheduleId : group.feeScheduleId;

          const fetchKey = `group-${groupIndex}-${feeScheduleId}-${isGlobal}`;

          if (feeScheduleId && !fetchedFeeSchedulesRef.current.has(fetchKey)) {
            fetchedFeeSchedulesRef.current.add(fetchKey);

            // Callback to update THIS group's rate labels when fetched
            const rateLabelCallback = (newFeeScheduleLabels) => {
              if (formikRef.current) {
                const hasTouched = Object.keys(formikRef.current.touched).length > 0;
                if (!hasTouched) {
                  const newValues = JSON.parse(JSON.stringify(formikRef.current.values));
                  newValues.ruleFeeScheduleGroupXref[groupIndex].rateLabels = newFeeScheduleLabels;
                  formikRef.current.resetForm({ values: newValues, initialValues: newValues });
                } else {
                  formikRef.current.setFieldValue(
                    `ruleFeeScheduleGroupXref[${groupIndex}].rateLabels`,
                    newFeeScheduleLabels
                  );
                }
              }
            };

            // Fetch from API (same function used by other architectures)
            getFeeScheduleLabels(feeScheduleId, rateLabelCallback, null, null, isGlobal);
          }
        });
      }

      if (initialValues.lesserOfConfiguration && initialValues.lesserOfConfiguration.length > 0) {
        initialValues.lesserOfConfiguration.forEach((entry, index) => {
          const feeScheduleId = entry.globalFeeScheduleId || entry.feeScheduleId;
          const isGlobalEntry = Boolean(entry.globalFeeScheduleId);
          const fetchKey = `lesserOf-${index}-${feeScheduleId}-${isGlobalEntry}`;

          if (feeScheduleId && !fetchedFeeSchedulesRef.current.has(fetchKey)) {
            fetchedFeeSchedulesRef.current.add(fetchKey);
            const rateLabelCallback = (newFeeScheduleLabels) => {
              if (formikRef.current) {
                const hasTouched = Object.keys(formikRef.current.touched).length > 0;
                if (!hasTouched) {
                  const newValues = JSON.parse(JSON.stringify(formikRef.current.values));
                  newValues.lesserOfConfiguration[index].rateLabels = newFeeScheduleLabels;
                  formikRef.current.resetForm({ values: newValues, initialValues: newValues });
                } else {
                  formikRef.current.setFieldValue(`lesserOfConfiguration[${index}].rateLabels`, newFeeScheduleLabels);
                }
              }
            };
            getFeeScheduleLabels(feeScheduleId, rateLabelCallback, null, null, isGlobalEntry);
          }
        });
      }

      if (initialValues.providerRolePaymentGroupXref && initialValues.providerRolePaymentGroupXref.length > 0) {
        initialValues.providerRolePaymentGroupXref.forEach((group, index) => {
          const feeScheduleId = group.globalFeeScheduleId || group.feeScheduleId;
          const isGlobalEntry = Boolean(group.globalFeeScheduleId);
          const fetchKey = `providerRole-${index}-${feeScheduleId}-${isGlobalEntry}`;

          if (feeScheduleId && !fetchedFeeSchedulesRef.current.has(fetchKey)) {
            fetchedFeeSchedulesRef.current.add(fetchKey);
            const rateLabelCallback = (newFeeScheduleLabels) => {
              if (formikRef.current) {
                const hasTouched = Object.keys(formikRef.current.touched).length > 0;
                if (!hasTouched) {
                  const newValues = JSON.parse(JSON.stringify(formikRef.current.values));
                  newValues.providerRolePaymentGroupXref[index].rateLabels = newFeeScheduleLabels;
                  formikRef.current.resetForm({ values: newValues, initialValues: newValues });
                } else {
                  formikRef.current.setFieldValue(`providerRolePaymentGroupXref[${index}].rateLabels`, newFeeScheduleLabels);
                }
              }
            };
            getFeeScheduleLabels(feeScheduleId, rateLabelCallback, null, null, isGlobalEntry);
          }
        });
      }
    }
  }, [initialValues, mode]);

  useEffect(() => {
    return function cleanup() {
      ruleErrorReset();
      resetCodesValidate();
    }
  }, [ruleErrorReset]);

  useEffect(() => {
    if (formikRef.current && formikRef.current.errors) {
      const errors = formikRef.current.errors;
      if (rulesValidateCodesError) {
        formikRef.current.setFieldError('carveoutCodes', 'Codes are incorrect');
      } else {
        delete errors.carveoutCodes;
        formikRef.current.setErrors(errors);
      }
    }
  }, [rulesValidateCodesError]);


  function handleGroupSelect(event, checked, id) {
    if (checked) {
      setSelectedGroups([...selectedGroups, id]);
    } else {
      const filteredGroups = selectedGroups.filter(x => x !== id);
      setSelectedGroups(filteredGroups);
    }
  }

  function isRuleType(ruleTypeId, keyword) {
    if (ruleTypeId && ruleTypes) {
      const ruleType = ruleTypes.find(x => x.id === ruleTypeId);
      if (ruleType) {
        return ruleType.name === keyword;
      }
    }
    return false;
  }

  function IsPaySourceTypeSchedule(paySourceId) {
    if (paySources && paySources.length > 0) {
      const paySource = paySources.find(x => x.id === paySourceId);
      if (paySource && paySource.name === PAY_SOURCE_SCHEDULE) {
        return true;
      }
    }

    return false;
  }

  function isPayMethod2ndDollar(payMethodId) {
    if (payMethods && payMethods.length > 0) {
      const payMethod = payMethods.find(item => item.id === payMethodId)
      if (payMethod && payMethod.name === PAY_METHOD_2ND_DOLLAR) {
        return true
      }
    }
    return false
  }

  function isPayMethodStopLoass(payMethodId) {
    if (payMethods && payMethods.length > 0) {
      const payMethod = payMethods.find(item => item.id === payMethodId)
      if (payMethod && payMethod.name === PAY_METHOD_STOP_LOSS) {
        return true
      }
    }
    return false
  }

  function isPayMethodPerDiemStopLoss(payMethodId) {
    if (filteredPayMethods && filteredPayMethods.length > 0) {
      const payMethod = filteredPayMethods.find(item => item.id === payMethodId)
      if (payMethod && payMethod.name === PAY_METHOD_PER_DIEM_STOP_LOSS) {
        return true
      }
    }
    return false
  }

  function isPayMethodFlatRate(payMethodId) {
    if (filteredPayMethods && filteredPayMethods.length > 0) {
      const payMethod = filteredPayMethods.find(item => item.id === payMethodId)
      if (payMethod && payMethod.name?.toLowerCase() ==='flat rate') {
        return true
      }
    }
    return false
  }

  function isPayMethodPercentage(payMethodId) {
    
    if (filteredPayMethods && filteredPayMethods.length > 0) {
      const payMethod = filteredPayMethods.find(item => item.id === payMethodId)
      if (payMethod && (payMethod.name?.toLowerCase() ==='percentage' || payMethod.name?.toLowerCase()?.includes('multiplier'))) {
        return true
      }
    }
    return false
  }

  function isPayMethodMultiProcedure(payMethodId) {
    if (modifiersPayMethods && modifiersPayMethods.length > 0) {
      const payMethod = modifiersPayMethods.find(item => item.id === payMethodId)
      if (payMethod && payMethod.name === MODIFIER_PAY_METHOD_MULTI_PROCEDURE) {
        return true
      }
    }
    return false
  }

  function areAllPayMethodsPerUnit(values) {
    if (IsPaySourceTypeSchedule(values.paySourceId)) {
      if (!values.ruleFeeScheduleGroupXref || values.ruleFeeScheduleGroupXref.length === 0) {
        return false;
      }

      return values.ruleFeeScheduleGroupXref.every(group => {
        const paymentMethods = group.rulePaymentFeeScheduleXRef || [];
        const splitMethods = group.ruleSplitPaymentXRef || [];

        const allItems = values.useSplitPayment ? splitMethods : paymentMethods;

        if (allItems.length === 0) {
          return false;
        }

        return allItems.every(item => item.isPerUnit);
      });
    }

    if (values.useSplitPayment) {
      if (!values.ruleSplitPaymentXref || values.ruleSplitPaymentXref.length === 0) {
        return false;
      }
      return values.ruleSplitPaymentXref.every(item => item.isPerUnit);
    } else {

      if (!IsPaySourceTypeSchedule(values.paySourceId) && values.useCustomPaymentDates) {
        if (!values.rulePaymentFeeScheduleXRef || values.rulePaymentFeeScheduleXRef.length === 0) {
          return false;
        }
        return values.rulePaymentFeeScheduleXRef.every(item => item.isPerUnit);
      }

      return values.isPerUnit;
    }
  }

  function isPayMethodAnesthesia(payMethodId) {
    if (payMethods && payMethods.length > 0) {
      const payMethod = payMethods.find(item => item.id === payMethodId);
      return payMethod && payMethod.name === 'Anesthesia';
    }
    return false;
  }

  const handleGroupPayMethodChange = (e, values, setFieldValue) => {
    const { name, value } = e.target;
    setFieldValue(name, value);

    setTimeout(() => {
      if (formikRef.current) {
        const currentValues = formikRef.current.values;
        if (currentValues.useBaseRate && !areAllPayMethodsPerUnit(currentValues)) {
          setFieldValue('useBaseRate', false);
        }
      }
    }, 0);
  };

  function IsPaySourceTypeChargeOrSchedule(paySourceId) {
    if (paySources && paySources.length > 0) {
      const paySource = paySources.find(x => x.id === paySourceId);
      if (paySource && (paySource.name === 'Charge' || paySource.name === 'Schedule')) {
        return true;
      }
    }

    return false;
  }
  function IsPaySourceType(paySourceId, targetType) {
    if (paySources && paySources.length > 0) {
      const paySource = paySources.find(x => x.id === paySourceId);
      if (paySource && paySource.name === targetType) {
        return true;
      }
    }
    return false;
  }

  function hasAnyStopLossPayMethod(values) {
    if (IsPaySourceTypeSchedule(values.paySourceId)) {
      return false;
    }
  
    const payments = values.rulePaymentFeeScheduleXRef ?? [];
    if (payments.length === 0) {
      return false;
    }
  
    return payments.some(payment => {
      const payMethodId = payment?.payMethodId;
      if (!payMethodId) {
        return false;
      }
  
      const payMethod = payMethods?.find(pm => pm.id === payMethodId);
      return (
        payMethod?.name === PAY_METHOD_STOP_LOSS ||
        payMethod?.name === PAY_METHOD_PER_DIEM_STOP_LOSS
      );
    });
  }    

  const saveAndResetHandler = (callBack) => {
    setShouldReset(true);
    callBack();

  }
  const onMenuClick = (option, callback, callbackSubmit, actionIndex) => {
    setSearchAction(option);

    if (callback) {
      callback();
    }
    if (option === 'Save and Add') {
      saveAndResetHandler(callbackSubmit);
    } else if (option === 'Save' && actionIndex === 0) {
      callbackSubmit();
    }
  };

  const loadNotesPage = (page: number) => {
    getNotes(
      NoteType.Rule,
      page + 1,
      NOTES_PAGE_SIZE,
      ruleId,
      toBackendNotesSort(notesSortModel),
    );
  };

  const handleOpenNotes = () => {
    setNotesSortModel(DEFAULT_NOTES_SORT);
    setNotesPage(0);
    getNotes(
      NoteType.Rule,
      1,
      NOTES_PAGE_SIZE,
      ruleId,
      toBackendNotesSort(DEFAULT_NOTES_SORT),
    );
    setNotesOpen(true);
  };

  const handleRefreshNotes = () => {
    loadNotesPage(notesPage);
  };

  const handleNotesPageChange = (nextPage: number) => {
    setNotesPage(nextPage);
    loadNotesPage(nextPage);
  };

  const handleNotesSortModelChange = (nextSortModel: GridSortModel) => {
    const normalizedSortModel = nextSortModel.filter((x) => x.sort === 'asc' || x.sort === 'desc');
    const safeSortModel = normalizedSortModel.length > 0 ? normalizedSortModel : DEFAULT_NOTES_SORT;
    setNotesSortModel(safeSortModel);
    setNotesPage(0);
    getNotes(
      NoteType.Rule,
      1,
      NOTES_PAGE_SIZE,
      ruleId,
      toBackendNotesSort(safeSortModel),
    );
  };

  const handleSaveNotes = ({ creates = [] }) => {
    const totalCreates = creates.length;
    if (totalCreates === 0) {
      return;
    }

    let pendingCreates = totalCreates;
    const onRequestDone = () => {
      pendingCreates -= 1;
      if (pendingCreates <= 0) {
        loadNotesPage(notesPage);
      }
    };

    creates.forEach((item) => {
      createNote({ type: item.type, note: item.note, entityId: item.entityId }, onRequestDone);
    });
  };

  const downloadBlob = (file: Blob, fileName: string) => {
    const url = URL.createObjectURL(file);
    const anchor = document.createElement('a');
    anchor.href = url;
    anchor.setAttribute('download', fileName || `Notes_${NoteType.Rule}.csv`);
    document.body.appendChild(anchor);
    anchor.click();
    document.body.removeChild(anchor);
    URL.revokeObjectURL(url);
  };

  const handleExportNotes = async ({
    scope,
    ids,
    page,
    pageSize,
    entityName,
  }: {
    scope: 'selected' | 'page' | 'all';
    ids?: number[];
    page?: number;
    pageSize?: number;
    entityName?: string;
  }) => {
    exportNotes(NoteType.Rule, scope, ids, page, pageSize, ruleId, entityName, (response) => {
      if (response?.file) {
        downloadBlob(response.file, response.fileName || `Notes_${NoteType.Rule}.csv`);
      }
    });
  };

  const handleCarveoutCodeChange = (setFieldValue) => (e) => {
    const withoutLineBreaks = e.target.value.replace(/[\r\n]/gm, '');
    setFieldValue('carveoutCodes', withoutLineBreaks)
  }

  function handleCarveoutCodeBlur() {
    if (formikRef.current && formikRef.current.values && formikRef.current.values.carveoutCodes) {
      ruleCodesValidate({
        "codes": formikRef.current.values.carveoutCodes,
        "ruleMethodId": formikRef.current.values.methodId
      });
    }
  }

  const handlePayMethodChange = (setFieldValue, setValues?) => (e) => {
    setFieldValue("paymethodId", e.target.value);
    if (filteredPayMethods && filteredPayMethods.length > 0) {
      const payMethod = filteredPayMethods.find(x => x.id === e.target.value);

      
      if (payMethod) {
        if (payMethod.name === PAY_METHOD_CASE_RATE || payMethod.name === PAY_METHOD_PER_DIEM) {
          setFieldValue("isCircuitBreaker", true)
        } else if (payMethod.name === PAY_METHOD_2ND_DOLLAR) {
          setFieldValue('threshold', true);
        } else if (payMethod.name === PAY_METHOD_STOP_LOSS) {
          setFieldValue('applyAt', 'Claim');
        } else if (payMethod.name === PAY_METHOD_PER_DIEM_STOP_LOSS) {
          setFieldValue('applyAt', 'Claim');
          const chargePaySource = paySources?.find(x => x.name === PAY_SOURCE_CHARGE);
          if (chargePaySource) {
            setFieldValue('paySourceId', chargePaySource.id);
          }
        }

        if (payMethod?.name?.toLowerCase() !== 'flat rate') { setFieldValue('isPerUnit', false); }
      }
    }

    setTimeout(() => {
      if (formikRef.current) {
        const currentValues = formikRef.current.values;
        if (currentValues.useBaseRate && !areAllPayMethodsPerUnit(currentValues)) {
          setFieldValue('useBaseRate', false);
        }
      }
    }, 0);
  }

  function handleClose() {
    setWarnOpen(false);
  }

  const serviceChangeHandler = (setFieldValue) => (e) => {
    if (e.target.value === 'none') {
      setFieldValue('codeServiceId', '');
    } else {
      setFieldValue('codeServiceId', e.target.value);
    }
  }

  function handleRuleChange(event, handleChange, setFieldValue) {
    handleChange(event);
    if (isRuleType(event.target.value, 'DEFAULT')) {
      setFieldValue('codeSelectionType', 'Codes');
      // if rule type is default  then change paysource to charge 
      if (paySources && paySources.length > 0) {
        const paySource = paySources.find(x => x.name === PAY_SOURCE_CHARGE);
        if (paySource) {
          setFieldValue('paySourceId', paySource?.id);
        }
      }
    }
  }
  function hoverColumn(text) {
    return (
      <PopoverLink
        columnData={<i className={`${classes.helpIcon} fas fa-question-circle text-info`}></i>}
        hoverData={[
          {
            data: text
          }
        ]}
      />
    );
  }

  function handleCodesOpen() {
    setCodeOpen(true);
  }
  function handleCodesClose() {
    setCodeOpen(false);
  }
  const handleCodesChange = (setFieldValue) => (codes, methodId) => {
    const withoutLineBreaks = codes.replace(/[\r\n]/gm, '');
    setFieldValue('carveoutCodes', withoutLineBreaks);
    ruleCodesValidate({ "codes": withoutLineBreaks, "ruleMethodId": methodId })
  }

  const handleApplyAtChange = (setFieldValue) => (e) => {
    setFieldValue('applyAt', e.target.value);
    if (e.target.value !== RULE_APPLY_AT_DATE_OF_SERVICE) {
      setFieldValue('dosMaxRate', 0);
    }
    if(e.target.value!=="Charge")
    {
      resetSplitFlow(setFieldValue)
    }
  }

  const handleCodeSelectionChange = (setFieldValue, values) => (e) => {
    setFieldValue("codeSelectionType", e.target.value);
    if (e.target.value === "Grouper") {
      setFieldValue("applyAt", "Rule");
      setFieldValue("useNpiRole", false);
    }
    if (e.target.value === "Fee Schedule" && isSelectedPaySourceSchedule(values.paySourceId)) {
      setFieldValue("usePaymentFeeSchedules", true);
    } else {
      setFieldValue("usePaymentFeeSchedules", false);
    }
};

  const handleFeeScheduleLabelToRateXrefChange = (id, setFieldValue, value, feeScheduleId) => {
    if(value && feeScheduleId) {
      getFeescheduleRateLabel(feeScheduleId, value.id, id, setFieldValue, feescheduleLabelToRateXRefChangeCallback);
    }
    else {
      setFieldValue(id, value ? value.id : null);
    }
  }

  const feescheduleLabelToRateXRefChangeCallback = (id, setFieldValue, labelId, newValue) => {
    setSelectedFeeScheduleLabelRates(prevItems => {
      const index = prevItems.findIndex(item => item.id === id);
      if (index !== -1) {
        // Update existing item
        const updatedItems = [...prevItems];
        updatedItems[index] = { ...updatedItems[index], value: newValue };
        return updatedItems;
      } else {
        // Add new item
        return [...prevItems, { id, value: newValue }];
      }
    });
    if(setFieldValue)
      setFieldValue(id, labelId);
  }

  const getFeescheduleLabelsCallback = (newFeeScheduleLabels, feeScheduleId, feescheduleLabelToRateXRefId, setFieldValue, useGlobal) => {
    if (!newFeeScheduleLabels || newFeeScheduleLabels.length === 0 || !setFieldValue) {
      if (useGlobal) {
        setFieldValue('globalFeescheduleLabelToRateXRefId', null);
      } else {
        setFieldValue('feescheduleLabelToRateXRefId', null);
      }
    }
    else {
      let foundLabel = newFeeScheduleLabels.find(x => x.id === feescheduleLabelToRateXRefId) || newFeeScheduleLabels.find(x => x.rateColumn === "Rate") || newFeeScheduleLabels[0];
      if(foundLabel){
        if (useGlobal) {
          setFieldValue('globalFeescheduleLabelToRateXRefId', foundLabel);
        } else {
          setFieldValue('feescheduleLabelToRateXRefId', foundLabel);
          getFeescheduleRateLabel(feeScheduleId, foundLabel.id, 'feescheduleLabelToRateXRefId', setFieldValue, feescheduleLabelToRateXRefChangeCallback);
        }
      }
    }
  }
  const isSelectedPaySourceCharge = (id) => {
    return paySources?.find((item) => item?.id === id)?.name === "Charge"
  }
  const isSelectedPaySourceSchedule = (id) => {
    return paySources?.find((item) => item?.id === id)?.name === "Schedule"
  }


  var shouldSplitPayments = (values) => {
    return (isSelectedPaySourceCharge(values.paySourceId) && values.applyAt === "Charge" && (values.codeSelectionType === "Code Service" || values.codeSelectionType === "Codes" || values.codeSelectionType === "Fee Schedule")) || (isSelectedPaySourceSchedule(values.paySourceId) && values.applyAt === "Charge")
  }


  const onClickAddSplitPaymentSection = (formValues) => {
    
    if (arrayPush) {
        const entries = formValues?.ruleSplitPaymentXref || [];
        const firstEntry = entries[0];

        // For global fee schedules, copy the first row's fee schedule data including rate label
        if (formValues?.useGlobalFeeSchedules && firstEntry && firstEntry.globalFeeScheduleId) {
            arrayPush({
                ...paySplit,
                globalFeeScheduleId: firstEntry.globalFeeScheduleId,
                feeScheduleName: firstEntry.feeScheduleName,
                requiresGlobalConfig: firstEntry.requiresGlobalConfig,
                selectedState: firstEntry.selectedState,
                selectedLocality: firstEntry.selectedLocality,
                selectedGpci: firstEntry.selectedGpci,
                rateLabels: firstEntry.rateLabels,
                feeSchedule: firstEntry.feeSchedule,
                feescheduleLabelToRateXRefId: firstEntry.feescheduleLabelToRateXRefId
            });
        } else if (!formValues?.useGlobalFeeSchedules && firstEntry && firstEntry.feeScheduleId) {
            // For local fee schedules, copy the first row's fee schedule data including rate label
            arrayPush({
                ...paySplit,
                feeScheduleId: firstEntry.feeScheduleId,
                feeScheduleName: firstEntry.feeScheduleName,
                rateLabels: firstEntry.rateLabels,
                feeSchedule: firstEntry.feeSchedule,
                feescheduleLabelToRateXRefId: firstEntry.feescheduleLabelToRateXRefId
            });
        } else {
            arrayPush({
                ...paySplit
            });
        }
    }
};

const bindArrayPush = (push) => {
  arrayPush = push;
};
var resetSplitFlow = (setFieldValue) => {
  setFieldValue("ruleSplitPaymentXref", [paySplit]);
  setFieldValue("useSplitPayment",false)
}

  // ========== VALIDATION HELPER FUNCTIONS ==========

  // Helper: Check if two unit ranges overlap based on equator and value(s)
  function checkUnitOverlap(entry1: any, entry2: any): boolean {
    const eq1 = entry1?.equator;
    const eq2 = entry2?.equator;
    const val1 = parseFloat(entry1?.value);
    const start1 = parseFloat(entry1?.startsAt);
    const end1 = parseFloat(entry1?.endsAt);
    const val2 = parseFloat(entry2?.value);
    const start2 = parseFloat(entry2?.startsAt);
    const end2 = parseFloat(entry2?.endsAt);


    // in_between AND in_between
    if (eq1 === 'in_between' && eq2 === 'in_between') {
      if (isNaN(start1) || isNaN(end1) || isNaN(start2) || isNaN(end2)) {
        return false;
      }
      const overlaps = start1 <= end2 && start2 <= end1;
      return overlaps;
    }

    // equals AND equals
    if (eq1 === 'equals' && eq2 === 'equals') {
      if (isNaN(val1) || isNaN(val2)) return false;
      const overlaps = val1 === val2;
      return overlaps;
    }

    // equals AND in_between
    if (eq1 === 'equals' && eq2 === 'in_between') {
      if (isNaN(val1) || isNaN(start2) || isNaN(end2)) return false;
      return val1 >= start2 && val1 <= end2;
    }
    if (eq1 === 'in_between' && eq2 === 'equals') {
      if (isNaN(start1) || isNaN(end1) || isNaN(val2)) return false;
      return val2 >= start1 && val2 <= end1;
    }

    // greater_than AND greater_than (always overlap - both extend to infinity)
    if ((eq1 === 'greater_than' || eq1 === 'greater_than_or_equals_to') &&
        (eq2 === 'greater_than' || eq2 === 'greater_than_or_equals_to')) {
      if (isNaN(val1) || isNaN(val2)) return false;
      return true;
    }

    // less_than AND less_than (always overlap - both extend to negative infinity)
    if ((eq1 === 'less_than' || eq1 === 'less_than_or_equals_to') &&
        (eq2 === 'less_than' || eq2 === 'less_than_or_equals_to')) {
      if (isNaN(val1) || isNaN(val2)) return false;
      return true;
    }

    // greater_than AND less_than
    if ((eq1 === 'greater_than' || eq1 === 'greater_than_or_equals_to') &&
        (eq2 === 'less_than' || eq2 === 'less_than_or_equals_to')) {
      if (isNaN(val1) || isNaN(val2)) return false;
      const min1 = eq1 === 'greater_than' ? val1 + 1 : val1;
      const max2 = eq2 === 'less_than' ? val2 - 1 : val2;
      return min1 <= max2;
    }
    if ((eq1 === 'less_than' || eq1 === 'less_than_or_equals_to') &&
        (eq2 === 'greater_than' || eq2 === 'greater_than_or_equals_to')) {
      if (isNaN(val1) || isNaN(val2)) return false;
      const max1 = eq1 === 'less_than' ? val1 - 1 : val1;
      const min2 = eq2 === 'greater_than' ? val2 + 1 : val2;
      return min2 <= max1;
    }

    // greater_than AND in_between
    if ((eq1 === 'greater_than' || eq1 === 'greater_than_or_equals_to') && eq2 === 'in_between') {
      if (isNaN(val1) || isNaN(start2) || isNaN(end2)) return false;
      const min1 = eq1 === 'greater_than' ? val1 + 1 : val1;
      return min1 <= end2;
    }
    if (eq1 === 'in_between' && (eq2 === 'greater_than' || eq2 === 'greater_than_or_equals_to')) {
      if (isNaN(start1) || isNaN(end1) || isNaN(val2)) return false;
      const min2 = eq2 === 'greater_than' ? val2 + 1 : val2;
      return min2 <= end1;
    }

    // less_than AND in_between
    if ((eq1 === 'less_than' || eq1 === 'less_than_or_equals_to') && eq2 === 'in_between') {
      if (isNaN(val1) || isNaN(start2) || isNaN(end2)) return false;
      const max1 = eq1 === 'less_than' ? val1 - 1 : val1;
      return start2 <= max1;
    }
    if (eq1 === 'in_between' && (eq2 === 'less_than' || eq2 === 'less_than_or_equals_to')) {
      if (isNaN(start1) || isNaN(end1) || isNaN(val2)) return false;
      const max2 = eq2 === 'less_than' ? val2 - 1 : val2;
      return start1 <= max2;
    }

    // greater_than AND equals
    if ((eq1 === 'greater_than' || eq1 === 'greater_than_or_equals_to') && eq2 === 'equals') {
      if (isNaN(val1) || isNaN(val2)) return false;
      return eq1 === 'greater_than' ? val2 > val1 : val2 >= val1;
    }
    if (eq1 === 'equals' && (eq2 === 'greater_than' || eq2 === 'greater_than_or_equals_to')) {
      if (isNaN(val1) || isNaN(val2)) return false;
      return eq2 === 'greater_than' ? val1 > val2 : val1 >= val2;
    }

    // less_than AND equals
    if ((eq1 === 'less_than' || eq1 === 'less_than_or_equals_to') && eq2 === 'equals') {
      if (isNaN(val1) || isNaN(val2)) return false;
      return eq1 === 'less_than' ? val2 < val1 : val2 <= val1;
    }
    if (eq1 === 'equals' && (eq2 === 'less_than' || eq2 === 'less_than_or_equals_to')) {
      if (isNaN(val1) || isNaN(val2)) return false;
      return eq2 === 'less_than' ? val1 < val2 : val1 <= val2;
    }

    return false;
  }

  // Helper: Check and add overlap errors for split payment arrays
  function checkAndAddOverlapErrors(splits: any[], errorsArray: any[]) {
    for (let i = 0; i < splits.length; i++) {
      for (let j = i + 1; j < splits.length; j++) {
        const split1 = splits[i];
        const split2 = splits[j];

        const hasOverlap = checkUnitOverlap(split1, split2);

        if (hasOverlap) {
          if (!errorsArray[i]) {
            errorsArray[i] = {};
          }
          if (!errorsArray[j]) {
            errorsArray[j] = {};
          }

          errorsArray[i].equator = `Unit range overlaps with split payment ${j + 1}`;
          errorsArray[j].equator = `Unit range overlaps with split payment ${i + 1}`;
        }
      }
    }
  }

  // Helper: Validate Fee Schedule Groups (Schedule pay source)
  function validateFeeScheduleGroups(values: any) {
    const groupsErrors: any[] = [];

    if (!values.ruleFeeScheduleGroupXref || values.ruleFeeScheduleGroupXref.length === 0) {
      return 'At least one fee schedule group is required';
    }

    values.ruleFeeScheduleGroupXref.forEach((group: any, groupIndex: number) => {
      const groupErrors: any = {};

      // 1. Validate Base Rate (when enabled)
      if (values.useBaseRate) {
        if (!group.baseRate && group.baseRate !== 0) {
          groupErrors.baseRate = 'Base Rate is required';
        } else if (group.baseRate <= 0) {
          groupErrors.baseRate = 'Base Rate must be positive';
        }
      }

      // 2. Validate Fee Schedule (local OR global)
      const hasFeeSchedule = values.useGlobalFeeSchedules
        ? group.globalFeeScheduleId
        : group.feeScheduleId;

      if (!hasFeeSchedule) {
        groupErrors.feeScheduleId = 'Fee Schedule is required';
      }

      // 3. Validate Rate Label (local OR global)
      if (hasFeeSchedule) {
        const hasRateLabel = values.useGlobalFeeSchedules
          ? group.globalFeescheduleLabelToRateXRefId
          : group.feescheduleLabelToRateXRefId;

        if (!hasRateLabel) {
          groupErrors.feescheduleLabelToRateXRefId = 'Rate Label is required';
        }
      }

      // 4. Validate Regional Fields (global RBRVS only)
      
      const isDME= group?.feeScheduleName?.toLowerCase()==="dme"
      if (values.useGlobalFeeSchedules && group.requiresGlobalConfig && hasFeeSchedule) {
        if (!group.selectedState && !group.globalFeescheduleState) {
          groupErrors.selectedState = 'State is required';
        }
        if (!group.selectedLocality && !group.globalFeescheduleLocality && !isDME) {
          groupErrors.selectedLocality = 'Locality is required';
        }
        if (!group.selectedGpci && !group.globalFeescheduleGPCI && !isDME) {
          groupErrors.selectedGpci = 'GPCI is required';
        }
      }

      // 5. Validate Custom Date Range (when useCustomDates is enabled)
      if (group.useCustomDates) {
        if (!group.customDateRange || !group.customDateRange.startdate || !group.customDateRange.enddate) {
          groupErrors.customDateRange = 'Date range is required when custom dates are enabled';
        } else {
          const startDate = new Date(group.customDateRange.startdate);
          const endDate = new Date(group.customDateRange.enddate);
          if (endDate <= startDate) {
            groupErrors.customDateRange = 'End date must be after start date';
          } else {
            // Validate that custom dates are within fee schedule date range (LOCAL schedules only)
            if (!values.useGlobalFeeSchedules && group.feeSchedule) {
              const feeSchedule = group.feeSchedule;
              if (feeSchedule.effectiveDate && feeSchedule.expirationDate) {
                const feeScheduleStartDate = new Date(feeSchedule.effectiveDate);
                const feeScheduleEndDate = new Date(feeSchedule.expirationDate);

                if (startDate < feeScheduleStartDate || endDate > feeScheduleEndDate) {
                  const formatDate = (date) => {
                    return `${date.getMonth() + 1}/${date.getDate()}/${date.getFullYear()}`;
                  };
                  groupErrors.customDateRange = `Custom dates must be within fee schedule date range (${formatDate(feeScheduleStartDate)} - ${formatDate(feeScheduleEndDate)})`;
                }
              }
            }
          }
        }
      }

      // 5. Validate Nested Payment Array (non-split)
      if (!values.useSplitPayment && hasFeeSchedule) {
        const paymentErrors = validateGroupPayments(group, values);
        if (paymentErrors && Object.keys(paymentErrors).length > 0) {
          groupErrors.rulePaymentFeeScheduleXRef = paymentErrors;
        }
      }

      // 6. Validate Nested Split Array (split payment)
      if (values.useSplitPayment && hasFeeSchedule) {
        const splitErrors = validateGroupSplits(group, values);
        if (splitErrors && Object.keys(splitErrors).length > 0) {
          groupErrors.ruleSplitPaymentXRef = splitErrors;
        }
      }

      if (Object.keys(groupErrors).length > 0) {
        groupsErrors[groupIndex] = groupErrors;
      }
    });

    if (values.ruleFeeScheduleGroupXref.length > 1) {
      for (let i = 0; i < values.ruleFeeScheduleGroupXref.length; i++) {
        for (let j = i + 1; j < values.ruleFeeScheduleGroupXref.length; j++) {
          const group1 = values.ruleFeeScheduleGroupXref[i];
          const group2 = values.ruleFeeScheduleGroupXref[j];

          // Only check overlaps if both groups have fee schedules selected
          const hasFeeSchedule1 = values.useGlobalFeeSchedules
            ? group1.globalFeeScheduleId
            : group1.feeScheduleId;
          const hasFeeSchedule2 = values.useGlobalFeeSchedules
            ? group2.globalFeeScheduleId
            : group2.feeScheduleId;

          if (!hasFeeSchedule1 || !hasFeeSchedule2) {
            continue;
          }

          let effectiveDate1, expirationDate1, effectiveDate2, expirationDate2;

          if (group1.useCustomDates && group1.customDateRange) {
            effectiveDate1 = group1.customDateRange.startdate;
            expirationDate1 = group1.customDateRange.enddate;
          } else {
            effectiveDate1 = group1.feeSchedule?.effectiveDate || group1.globalFeeSchedule?.effectiveDate;
            expirationDate1 = group1.feeSchedule?.expirationDate || group1.globalFeeSchedule?.expirationDate;
          }

          if (group2.useCustomDates && group2.customDateRange) {
            effectiveDate2 = group2.customDateRange.startdate;
            expirationDate2 = group2.customDateRange.enddate;
          } else {
            effectiveDate2 = group2.feeSchedule?.effectiveDate || group2.globalFeeSchedule?.effectiveDate;
            expirationDate2 = group2.feeSchedule?.expirationDate || group2.globalFeeSchedule?.expirationDate;
          }

          if (!effectiveDate1 || !expirationDate1 || !effectiveDate2 || !expirationDate2) {
            continue;
          }

          const from1 = new Date(effectiveDate1);
          const to1 = new Date(expirationDate1);
          const from2 = new Date(effectiveDate2);
          const to2 = new Date(expirationDate2);

          if (from1 <= to2 && from2 <= to1) {
            if (!groupsErrors[i]) {
              groupsErrors[i] = {};
            }
            if (!groupsErrors[j]) {
              groupsErrors[j] = {};
            }

            groupsErrors[i].feeScheduleId = `Date range overlaps with group ${j + 1}`;
            groupsErrors[j].feeScheduleId = `Date range overlaps with group ${i + 1}`;
          }
        }
      }
    }

    return groupsErrors.length > 0 && groupsErrors.some(e => e !== undefined)
      ? groupsErrors
      : undefined;
  }

  // Helper: Validate Group Payments (non-split)
  function validateGroupPayments(group: any, values: any) {
    const paymentsErrors: any[] = [];

    if (!group.rulePaymentFeeScheduleXRef || group.rulePaymentFeeScheduleXRef.length === 0) {
      return ['At least one payment entry is required'];
    }

    group.rulePaymentFeeScheduleXRef.forEach((payment: any, paymentIndex: number) => {
      const paymentErrors: any = {};

      if (!payment.payMethodId) {
        paymentErrors.payMethodId = 'Pay Method is required';
      }

      if (payment.payValue === null || payment.payValue === '' || payment.payValue === undefined) {
        paymentErrors.payValue = 'Pay Value is required';
      } else if (payment.payValue < 0) {
        paymentErrors.payValue = 'Pay Value must be positive';
      }

      if (values.applyAt === RULE_APPLY_AT_DATE_OF_SERVICE) {
        if (payment.dosMaxRate === null || payment.dosMaxRate === '' || payment.dosMaxRate === undefined) {
          paymentErrors.dosMaxRate = 'DOS Max Rate is required';
        }
      }

      if (isPayMethodAnesthesia(payment.payMethodId) && payment.useMinutesPerUnit) {
        if (!payment.minutesPerUnit || payment.minutesPerUnit <= 0) {
          paymentErrors.minutesPerUnit = 'Minutes Per Unit is required and must be greater than 0';
        }
      }

      if (Object.keys(paymentErrors).length > 0) {
        paymentsErrors[paymentIndex] = paymentErrors;
      }
    });

    return paymentsErrors.length > 0 && paymentsErrors.some(e => e !== undefined)
      ? paymentsErrors
      : undefined;
  }

  // Helper: Validate Group Splits (split payment)
  function validateGroupSplits(group: any, values: any) {
    const splitsErrors: any[] = [];

    if (!group.ruleSplitPaymentXRef || group.ruleSplitPaymentXRef.length === 0) {
      return ['At least one split entry is required'];
    }

    group.ruleSplitPaymentXRef.forEach((split: any, splitIndex: number) => {
      const splitErrors: any = {};

      // Required fields
      if (!split.equator) {
        splitErrors.equator = 'Equator is required';
      }

      if (!split.payMethodId) {
        splitErrors.payMethodId = 'Pay Method is required';
      }

      if (split.payValue === null || split.payValue === '' || split.payValue === undefined) {
        splitErrors.payValue = 'Pay Value is required';
      } else if (split.payValue < 0) {
        splitErrors.payValue = 'Pay Value must be positive';
      }

      // Value validation based on equator
      if (split.equator === 'in_between') {
        if (split.startsAt === null || split.startsAt === '' || split.startsAt === undefined) {
          splitErrors.startsAt = 'Start value is required';
        }
        if (split.endsAt === null || split.endsAt === '' || split.endsAt === undefined) {
          splitErrors.endsAt = 'End value is required';
        }
        if (split.startsAt !== null && split.endsAt !== null && split.endsAt <= split.startsAt) {
          splitErrors.endsAt = 'End value must be greater than Start value';
        }
      } else {
        if (split.value === null || split.value === '' || split.value === undefined) {
          splitErrors.value = 'Value is required';
        }
      }

      if (Object.keys(splitErrors).length > 0) {
        splitsErrors[splitIndex] = splitErrors;
      }
    });

    // Check for unit overlaps within the same group's split payments
    checkAndAddOverlapErrors(group.ruleSplitPaymentXRef, splitsErrors);

    const result = splitsErrors.length > 0 && splitsErrors.some(e => e !== undefined)
      ? splitsErrors
      : undefined;
    return result;
  }

  // Helper: Validate Charge Split Payments (direct on rule)
  function validateChargeSplitPayments(values: any) {
    const splitsErrors: any[] = [];

    if (!values.ruleSplitPaymentXref || values.ruleSplitPaymentXref.length === 0) {
      return 'At least one split payment entry is required';
    }

    values.ruleSplitPaymentXref.forEach((split: any, splitIndex: number) => {
      const splitErrors: any = {};

      // Same validation as group splits, but without fee schedule checks
      if (!split.equator) {
        splitErrors.equator = 'Equator is required';
      }

      if (!split.payMethodId) {
        splitErrors.payMethodId = 'Pay Method is required';
      }

      if (split.payValue === null || split.payValue === '' || split.payValue === undefined) {
        splitErrors.payValue = 'Pay Value is required';
      } else if (split.payValue < 0) {
        splitErrors.payValue = 'Pay Value must be positive';
      }

      if (split.equator === 'in_between') {
        if (split.startsAt === null || split.startsAt === '' || split.startsAt === undefined) {
          splitErrors.startsAt = 'Start value is required';
        }
        if (split.endsAt === null || split.endsAt === '' || split.endsAt === undefined) {
          splitErrors.endsAt = 'End value is required';
        }
        if (split.startsAt !== null && split.endsAt !== null && split.endsAt <= split.startsAt) {
          splitErrors.endsAt = 'End value must be greater than Start value';
        }
      } else {
        if (split.value === null || split.value === '' || split.value === undefined) {
          splitErrors.value = 'Value is required';
        }
      }

      if (Object.keys(splitErrors).length > 0) {
        splitsErrors[splitIndex] = splitErrors;
      }
    });

    // Check for unit overlaps within charge split payments
    checkAndAddOverlapErrors(values.ruleSplitPaymentXref, splitsErrors);

    const result = splitsErrors.length > 0 && splitsErrors.some(e => e !== undefined)
      ? splitsErrors
      : undefined;
    return result;
  }

  function validateLesserOfSection(values: any) {   
    const lesserOfErrors: any[] = [];

    if (!values.lesserOfConfiguration || values.lesserOfConfiguration.length === 0) {
      return 'At least one lesser configuration is required';
    }

    values.lesserOfConfiguration.forEach((lesserOfConfig: any, index: number) => {
      const lesserOfItemErrors: any = {};

      if (!lesserOfConfig.lesserOfType) {
        lesserOfItemErrors.lesserOfType = 'Required field';
      }

      if (!lesserOfConfig.percentage) {
        lesserOfItemErrors.percentage = 'Required field';
      }

      if(lesserOfConfig.lesserOfType === "FeeSchedule") {
        // Validate Fee Schedule (local OR global)
        const hasFeeSchedule = values.useGlobalFsForLesserOf
        ? lesserOfConfig.globalFeeScheduleId
        : lesserOfConfig.feeScheduleId;

        if (!hasFeeSchedule) {
          lesserOfItemErrors.feeScheduleId = 'Fee Schedule is required';
        }

        // Validate Rate Label (local OR global)
        if (hasFeeSchedule) {
          const hasRateLabel = values.useGlobalFsForLesserOf
            ? lesserOfConfig.globalFeescheduleLabelToRateXRefId
            : lesserOfConfig.feescheduleLabelToRateXRefId;

          if (!hasRateLabel) {
            lesserOfItemErrors.feescheduleLabelToRateXRefId = 'Rate Label is required';
          }
        }

        // Validate Regional Fields (global RBRVS only)
        const isDME= lesserOfConfig?.feeScheduleName?.toLowerCase()?.includes("dme");
        if (values.useGlobalFsForLesserOf && lesserOfConfig.requiresGlobalConfig && hasFeeSchedule) {
          if (!lesserOfConfig.selectedState && !lesserOfConfig.globalFeescheduleState) {
            lesserOfItemErrors.selectedState = 'State is required';
          }
          if (!lesserOfConfig.selectedLocality && !lesserOfConfig.globalFeescheduleLocality && !isDME) {
            lesserOfItemErrors.selectedLocality = 'Locality is required';
          }
          if (!lesserOfConfig.selectedGpci && !lesserOfConfig.globalFeescheduleGPCI && !isDME) {
            lesserOfItemErrors.selectedGpci = 'GPCI is required';
          }
        }
      }

      if (Object.keys(lesserOfItemErrors).length > 0) {
        lesserOfErrors[index] = lesserOfItemErrors;
      }
    });

    return lesserOfErrors.length > 0 && lesserOfErrors.some(e => e !== undefined)
      ? lesserOfErrors
      : undefined;
  }

  const handleLesserOfGlobalFSDisable = (useGlobalFsForLesserOf, setFieldValue, lesserOfConfiguration) => {
    const hasTypeSchedule = lesserOfConfiguration?.some(item => item.lesserOfType === "FeeSchedule");
    
    if(useGlobalFsForLesserOf && !hasTypeSchedule) {
      setFieldValue('useGlobalFsForLesserOf', false);
    }

    return hasTypeSchedule ? false: true;
  }

  function validateProviderRolePaymentGroupSection(values: any) {
    const paymentGroupErrors: any[] = [];
  
    let hasAtLeastOneGroup = false;
    let hasAtLeastOneGroupWithCriteria = false;
  
    values.providerRolePaymentGroupXref.forEach((group: any, index: number) => {
      const groupErrors: any = {};
  
      const hasAnyValue =
        group.payMethodId ||
        group.payValue ||
        group.feeScheduleId ||
        group.globalFeeScheduleId ||
        group.feeScheduleLabelToRateXRefId ||
        group.globalFeeScheduleLabelToRateXRefId ||
        group.selectedState ||
        group.selectedLocality ||
        group.selectedGpci;
  
      if (hasAnyValue) {
        hasAtLeastOneGroup = true;
  
        // Group-level required fields
        if (!group.payMethodId) {
          groupErrors.payMethodId = 'Required field';
        }
  
        if (group.payValue === null || group.payValue === undefined || group.payValue === '') {
          groupErrors.payValue = 'Required field';
        }
  
        const isGlobal = group.useGlobalFeeSchedules === true;
        const hasFeeSchedule = isGlobal
          ? group.globalFeeScheduleId
          : group.feeScheduleId;
  
        if (!hasFeeSchedule && IsPaySourceTypeSchedule(values.paySourceId)) {
          groupErrors.feeScheduleId = 'Fee Schedule is required';
        }
  
        if (hasFeeSchedule) {
          const hasRateLabel = isGlobal
            ? group.globalFeeScheduleLabelToRateXRefId
            : group.feeScheduleLabelToRateXRefId;
  
          if (!hasRateLabel) {
            if (isGlobal) {
              groupErrors.globalFeeScheduleLabelToRateXRefId = 'Rate Label is required';
            } else {
              groupErrors.feeScheduleLabelToRateXRefId = 'Rate Label is required';
            }
          }
        }
  
        const isDME= group?.feeScheduleName?.toLowerCase()==="dme"

        if (isGlobal && group.requiresGlobalConfig && hasFeeSchedule) {
          if (!group.selectedState && !group.globalFeescheduleState) {
            groupErrors.selectedState = 'State is required';
          }
          if (!group.selectedLocality && !group.globalFeescheduleLocality && !isDME) {
            groupErrors.selectedLocality = 'Locality is required';
          }
          if (!group.selectedGpci && !group.globalFeescheduleGPCI && !isDME) {
            groupErrors.selectedGpci = 'GPCI is required';
          }
        }

        // Validate Anesthesia case
        if (isPayMethodAnesthesia(group.payMethodId) && group.useMinutesPerUnit) {
          if (!group.minutesPerUnit || group.minutesPerUnit <= 0) {
            groupErrors.minutesPerUnit = 'Minutes Per Unit is required and must be greater than 0';
          }
        }
      }
  
      // Criteria validation
      const criteria = group.providerRolePaymentCriteriaXref || [];
  
      const filledCriteria = criteria.filter(c =>
        c.providerRoleSelectionCriteriaId ||
        c.equator ||
        (c.value !== '' && c.value !== null && c.value !== undefined) || 
        (c.startsAt !== '' && c.startsAt !== null && c.startsAt !== undefined) || 
        (c.endsAt !== '' && c.endsAt !== null && c.endsAt !== undefined)
      );
  
      if (hasAnyValue) {
        if (filledCriteria.length > 0) {
          hasAtLeastOneGroupWithCriteria = true;
        } else {
          groupErrors.payMethodId =
            groupErrors.payMethodId ||
            'At least one criteria is required for this payment group';
        }
      }
  
      if (filledCriteria.length > 0) {
        const criteriaErrors = filledCriteria.map((row: any) => {
          const rowErrors: any = {};
  
          if (!row.providerRoleSelectionCriteriaId) {
            rowErrors.providerRoleSelectionCriteriaId = 'Criteria is required';
          }
          if (!row.equator) {
            rowErrors.equator = 'Equator is required';
          }

          // Value validation based on equator
          if (row.equator === 'in_between' || row.equator === 'alpha_between') {
            if (row.startsAt === null || row.startsAt === '' || row.startsAt === undefined) {
              rowErrors.startsAt = 'Start value is required';
            }
            if (row.endsAt === null || row.endsAt === '' || row.endsAt === undefined) {
              rowErrors.endsAt = 'End value is required';
            }
            if ((row.startsAt !== '' && row.startsAt !== null && row.startsAt !== undefined) && 
            (row.endsAt !== '' && row.endsAt !== null && row.endsAt !== undefined) && row.endsAt <= row.startsAt) {
              rowErrors.endsAt = 'End value must be greater than Start value';
            }
          } else {
            if (row.value === '' || row.value === null || row.value === undefined) {
              rowErrors.value = 'Value is required';
            }
          }
  
          return Object.keys(rowErrors).length ? rowErrors : null;
        });
  
        if (criteriaErrors.some(e => e !== null)) {
          groupErrors.providerRolePaymentCriteriaXref = criteriaErrors;
        }
      }
  
      if (Object.keys(groupErrors).length > 0) {
        paymentGroupErrors[index] = groupErrors;
      }
    });
  
    if (!hasAtLeastOneGroup) {
      paymentGroupErrors[0] = {
        ...(paymentGroupErrors[0] || {}),
        payMethodId: 'At least one payment group is required'
      };
    } else if (!hasAtLeastOneGroupWithCriteria) {
      paymentGroupErrors[0] = {
        ...(paymentGroupErrors[0] || {}),
        payMethodId: 'At least one payment group must have at least one criteria'
      };
    }
  
    return paymentGroupErrors.some(e => e !== undefined)
      ? paymentGroupErrors
      : undefined;
  }  
  

  const actions = ['Save', 'Save and Add'];

  return (<>
    <Loadable loading={rulesGetPending || rulesCreatePending || rulesUpdatePending || codeServicesTinyPending || getFeescheduleLabelsPending || getFeescheduleRateLabelPending || !serviceType}>
      <Formik
        enableReinitialize={true}
        initialValues={initialValues}
        innerRef={formikRef}
        key={ruleId}
        // validationSchema={mode === 'create' ? addValidationSchema : addValidationSchema}
        validate={values => {

          const errors : Record<string,any> = {};
          const npiRegex = /^\d{10}$/;
          if (!values.name) {
            errors.name = intl.formatMessage({
              id: "AUTH.VALIDATION.REQUIRED_FIELD"
            });
          }
          // else if (!values.name.match(alphaNumericSpacePattern)) {
          //   errors.name = "Only alpha numeric values are allowed";
          // }

          if (!values.ruleTypeId) {
            errors.ruleTypeId = intl.formatMessage({
              id: "AUTH.VALIDATION.REQUIRED_FIELD"
            });
          }
          if (isRuleType(values.ruleTypeId, 'DEFAULT')) {
            if (!values.methodId) {
              errors.methodId = intl.formatMessage({
                id: "AUTH.VALIDATION.REQUIRED_FIELD"
              });
            }
          }
          if (values.codeSelectionType === 'Codes' && !isRuleType(values.ruleTypeId, 'DEFAULT')) {
            if (!values.methodId) {
              errors.methodId = intl.formatMessage({
                id: "AUTH.VALIDATION.REQUIRED_FIELD"
              });
            }
          }

          if (values.maxRate) {
            if (!values.maxRateValue) {
              errors.maxRateValue = intl.formatMessage({
                id: "AUTH.VALIDATION.REQUIRED_FIELD"
              });
            }
          }
          if (values.threshold) {
            if (!values.thresholdValue) {
              errors.thresholdValue = intl.formatMessage({
                id: "AUTH.VALIDATION.REQUIRED_FIELD"
              });
            }
          }

          if (!IsPaySourceTypeSchedule(values.paySourceId) && !values?.useSplitPayment && !values?.useCustomPaymentDates && !values.paymethodId) {
            errors.paymethodId = intl.formatMessage({
              id: "AUTH.VALIDATION.REQUIRED_FIELD"
            });
          }

          if (!values.paySourceId) {
            errors.paySourceId = intl.formatMessage({
              id: "AUTH.VALIDATION.REQUIRED_FIELD"
            });
          }

          if (!values.description) {
            errors.description = intl.formatMessage({
              id: "AUTH.VALIDATION.REQUIRED_FIELD"
            });
          }
          if (!IsPaySourceTypeSchedule(values.paySourceId) && !values?.useSplitPayment && !values?.useCustomPaymentDates && ((!values.payvalue && values.payvalue !== 0) || (values.payvalue < 0))) {
            if (values.payvalue < 0) {
              errors.payvalue = "Negative Values are not allowed";
            }
            else {
              errors.payvalue = intl.formatMessage({
                id: "AUTH.VALIDATION.REQUIRED_FIELD"
              });
            }
          }


          if ((isRuleType(values.ruleTypeId, 'CARVEOUT') ||
            isRuleType(values.ruleTypeId, 'RULE'))
            && values.codeSelectionType === "Codes"
            && !values.carveoutCodes) {
            errors.carveoutCodes = intl.formatMessage({
              id: "AUTH.VALIDATION.REQUIRED_FIELD"
            });
          }
          if ((isRuleType(values.ruleTypeId, 'RULE') || isRuleType(values.ruleTypeId, 'CARVEOUT'))
            && values.codeSelectionType === "Code Service"
            && !values.codeServiceId) {
            errors.codeServiceId = intl.formatMessage({
              id: "AUTH.VALIDATION.REQUIRED_FIELD"
            });
          }

          if(values.codeSelectionType === 'Grouper' && !values.grouperConfigurationId) {
            errors.grouperConfigurationId = intl.formatMessage({
              id: "AUTH.VALIDATION.REQUIRED_FIELD"
            });
          }

          // Validate top-level fee schedule fields (when Code Selection Type = Fee Schedule and toggle off)
          if (values.codeSelectionType === "Fee Schedule" && !values.usePaymentFeeSchedules) {
            const hasFeeSchedule = values.globalFeeScheduleId || values.feeScheduleId;
            if (!hasFeeSchedule) {
              errors.feeScheduleId = intl.formatMessage({
                id: "AUTH.VALIDATION.REQUIRED_FIELD"
              });
            }
          }


          if (rulesValidateCodesError) {
            errors.carveoutCodes = intl.formatMessage({
              id: "RULE.INVALID.CODES"
            });
          }
          if (Boolean(values.useMultiProcedurePercent) === true) {
            const multiPrecidenceError = values.multiProcedurePercents.map((multiProc) => {
              const multiPrecidenceError = {};
              let hasError = false;
              
              if (!multiProc.percentage && multiProc.percentage!==0) {
                multiPrecidenceError['percentage'] = intl.formatMessage({
                  id: "AUTH.VALIDATION.REQUIRED_FIELD"
                });
                hasError = true;
              }
              if (multiProc.percentage<0) {
                multiPrecidenceError['percentage'] = "Only Positive Values";
                hasError=true

              }

              if (!multiProc.precedenceId) {
                multiPrecidenceError['precedenceId'] = intl.formatMessage({
                  id: "AUTH.VALIDATION.REQUIRED_FIELD"
                });
                hasError = true;
              }

              if (hasError) {
                return multiPrecidenceError;
              }

              return false;
            });

            const filteredArray = multiPrecidenceError.filter(value => Object.keys(value).length > 0);

            if (filteredArray.length > 0) {
              errors['multiProcedurePercents'] = multiPrecidenceError;
            }
          }

          if (values.isSometimesPay) {
            if (!commaSeparatedPattern.test(values.sometimesPayCodes)) {
              errors.sometimesPayCodes = 'Codes should be only in comma separated format';
            }
          }

          if (IsPaySourceTypeChargeOrSchedule(values.paySourceId) && Boolean(values.useNpiRate) === true) {
            const ruleNPIRateError = values.ruleToNpirateXref.map((multiProc, index) => {
              const ruleNPIRateError = {};
              
              let hasError = false;

              if (!multiProc.npi) {
                ruleNPIRateError['npi'] = intl.formatMessage({
                  id: "AUTH.VALIDATION.REQUIRED_FIELD"
                });
                hasError = true;
              }

              if (multiProc.npi && !npiRegex.test(multiProc.npi)) {
                ruleNPIRateError['npi'] = "NPI Must be a 10 Digit Number";
                hasError = true;
              }

              if (multiProc.rate?.length === 0) {
                ruleNPIRateError['rate'] = intl.formatMessage({
                  id: "AUTH.VALIDATION.REQUIRED_FIELD"
                });
                hasError = true;
              }
              if (IsPaySourceType(values.paySourceId, 'Schedule') && multiProc.rate?.length !== 0 && (multiProc.rate < 0)) {
                ruleNPIRateError['rate'] = 'The percentage must be greater than 0';
                hasError = true;
              }

              if (IsPaySourceType(values.paySourceId, 'Schedule')) {
                const isGlobal = values.useGlobalFeeSchedules || false;

                const hasFirstGroupFeeSchedule = values.ruleFeeScheduleGroupXref &&
                  values.ruleFeeScheduleGroupXref.length > 0 &&
                  (isGlobal ? values.ruleFeeScheduleGroupXref[0].globalFeeScheduleId : values.ruleFeeScheduleGroupXref[0].feeScheduleId);

                if (hasFirstGroupFeeSchedule) {
                  const rateLabelFieldName = isGlobal ? 'globalFeescheduleLabelToRateXRefId' : 'feescheduleLabelToRateXRefId';

                  if (!multiProc[rateLabelFieldName]) {
                    ruleNPIRateError[rateLabelFieldName] = intl.formatMessage({
                      id: "AUTH.VALIDATION.REQUIRED_FIELD"
                    });
                    hasError = true;
                  }
                }
              }

              if (hasError) {
                return ruleNPIRateError;
              }

              return false;
            });

            const filteredArray = ruleNPIRateError.filter(value => Object.keys(value).length > 0);

            if (filteredArray.length > 0) {
              errors['ruleToNpirateXref'] = ruleNPIRateError;
            }
          }

          
          
          // Modifier Error
          if (values.useModifiers) {
            const ruleToModifierError = values.ruleToModifierXref.map((modifier) => {
              const modifierError = {};
              let hasError = false;

              if (!modifier.modifierId) {
                modifierError['modifierId'] = intl.formatMessage({
                  id: "AUTH.VALIDATION.REQUIRED_FIELD"
                });
                hasError = true;
              }

              if (!modifier.payMethodId) {
                modifierError['payMethodId'] = intl.formatMessage({
                  id: "AUTH.VALIDATION.REQUIRED_FIELD"
                });
                hasError = true;
              }

              if (isPayMethodMultiProcedure(modifier.payMethodId)) {
                const emptyItem = modifier?.modifierMultiProcedurePercentage?.find(item => item.occurance === '' || item.value === '');
                if (emptyItem) {
                  modifierError['modifierMultiProcedurePercentage'] = intl.formatMessage({
                    id: "AUTH.VALIDATION.REQUIRED_FIELD"
                  });
                  hasError = true;
                }
              } else {
                if (modifier.value?.length === 0) {
                  modifierError['value'] = intl.formatMessage({
                    id: "AUTH.VALIDATION.REQUIRED_FIELD"
                  });
                  hasError = true;
                }
                if (modifier?.value<0) {
                  modifierError['value'] = "Only Positive Values";
                  hasError=true
                }
              }

              if (hasError) {
                return modifierError;
              }

              return false;
            });
            const filteredModifierError = ruleToModifierError.filter(value => Object.keys(value).length > 0);

            if (filteredModifierError.length > 0) {
              errors['ruleToModifierXref'] = ruleToModifierError;
            }
          }

          // Rule Selection Criteria Error
          const ruleCriteriaError = values.ruleSelectionCriteriaXref.map((crite,index) => {
            const criteriaError = {};

            let hasError = false;
            if (crite.ruleSelectionCriteriaId !== null) {

              if (crite.ruleSelectionCriteriaId?.id === 5 && !IsPaySourceType(values.paySourceId, 'Schedule')) {
                criteriaError['ruleSelectionCriteriaId'] = "Provider Role must be selected for schedule pay source.";
                hasError = true;
              }

              if (!crite.equator) {
                criteriaError['equator'] = intl.formatMessage({
                  id: "AUTH.VALIDATION.REQUIRED_FIELD"
                });
                hasError = true;
              }

              // Validate based on operator type
              if (crite.equator === 'alpha_between' || crite.equator === 'in_between') {
                // For between operators, validate startsAt and endsAt
                if (!crite.startsAt) {
                  criteriaError['startsAt'] = intl.formatMessage({
                    id: "AUTH.VALIDATION.REQUIRED_FIELD"
                  });
                  hasError = true;
                }
                if (!crite.endsAt) {
                  criteriaError['endsAt'] = intl.formatMessage({
                    id: "AUTH.VALIDATION.REQUIRED_FIELD"
                  });
                  hasError = true;
                }
                // Validate that endsAt is greater than startsAt
                if (
                  crite.equator === 'in_between' &&
                  crite.startsAt &&
                  crite.endsAt &&
                  parseInt(crite.endsAt) < parseInt(crite.startsAt)
                ) {
                  criteriaError['endsAt'] = 'End Range Must be Greater than start Range';
                  hasError = true;
                }

                if (crite.equator === 'in_between') {
                  if (crite.startsAt) {
                    const startsAtNum = Number(crite.startsAt);
                    if (startsAtNum < 0) {
                      criteriaError['startsAt'] = 'Start value cannot be negative';
                      hasError = true;
                    } else if (!Number.isInteger(startsAtNum)) {
                      criteriaError['startsAt'] = 'Start value must be a whole number';
                      hasError = true;
                    }
                  }
                  if (crite.endsAt && !criteriaError['endsAt']) {
                    const endsAtNum = Number(crite.endsAt);
                    if (endsAtNum < 0) {
                      criteriaError['endsAt'] = 'End value cannot be negative';
                      hasError = true;
                    } else if (!Number.isInteger(endsAtNum)) {
                      criteriaError['endsAt'] = 'End value must be a whole number';
                      hasError = true;
                    }
                  }
                }

                if (
                  crite.equator === 'alpha_between' &&
                  crite.startsAt &&
                  crite.endsAt &&
                  crite.endsAt.toString().toLowerCase() < crite.startsAt.toString().toLowerCase()
                ) {
                  criteriaError['endsAt'] = 'End value must come after start value alphabetically';
                  hasError = true;
                }
              } else {
                // For other operators, validate value
                if (!crite.value) {
                  criteriaError['value'] = intl.formatMessage({
                    id: "AUTH.VALIDATION.REQUIRED_FIELD"
                  });
                  hasError = true;
                }

                if (crite.value && (crite.type === 'int' || crite.type === 'long')) {
                  const valueNum = Number(crite.value);
                  if (valueNum < 0) {
                    criteriaError['value'] = 'Value cannot be negative';
                    hasError = true;
                  } else if (!Number.isInteger(valueNum)) {
                    criteriaError['value'] = 'Value must be a whole number';
                    hasError = true;
                  }
                }
              }
            }

            if(crite.ruleSelectionCriteriaId?.id === 5 && crite.value && values.ruleSelectionCriteriaXref?.some((x, ind) => index !== ind && x.ruleSelectionCriteriaId?.id === 5 && x.value == crite.value)) {
              criteriaError['value'] = "Duplicate selection criteria are not allowed.";
              hasError = true;
            }

            for (let i = index - 1; i >= 0; i--) {
              const previous = values.ruleSelectionCriteriaXref[i];
              const doesCriteriaNameMatces =
                  crite.ruleSelectionCriteriaId?.name ===
                  previous.ruleSelectionCriteriaId?.name;
              const validationMsg =
                  "Duplicate selection criteria are not allowed. Please review your input";

              const critIsBetween = crite.equator === 'alpha_between' || crite.equator === 'in_between';
              const prevIsBetween = previous.equator === 'alpha_between' || previous.equator === 'in_between';

              if (
                  critIsBetween &&
                  prevIsBetween &&
                  crite.startsAt === previous.startsAt &&
                  crite.endsAt === previous.endsAt &&
                  doesCriteriaNameMatces
              ) {
                  criteriaError["startsAt"] = validationMsg;
                  hasError = true;
                  break;
              } else if (
                  !critIsBetween &&
                  !prevIsBetween &&
                  crite.value === previous.value &&
                  crite.equator === previous.equator &&
                  crite.ruleSelectionCriteriaId?.name ===
                      previous.ruleSelectionCriteriaId?.name
              ) {
                  criteriaError["value"] = validationMsg;
                  hasError = true;
                  break;
              }
          }
            if (hasError) {
              return criteriaError;
            }


            return false;

          });
          const filteredCriteriaError = ruleCriteriaError.filter(value => Object.keys(value).length > 0);

          if (filteredCriteriaError.length > 0) {
            errors['ruleSelectionCriteriaXref'] = ruleCriteriaError;
          }

          if(values?.lesserOf) {
            const lesserOfSectionErrors = validateLesserOfSection(values);
            if (lesserOfSectionErrors) {
              errors.lesserOfConfiguration = lesserOfSectionErrors;
            }
          }

          if (serviceType === CONTRACTED_SERVICE_PROFESSIONAL && Boolean(values.useNpiRole) === true) {
            const providerRoleSectionErrors = validateProviderRolePaymentGroupSection(values);
            if (providerRoleSectionErrors) {
              errors.providerRolePaymentGroupXref = providerRoleSectionErrors;
            }
          }

// ========== PAYMENT/SPLIT VALIDATION ==========

          // ========== SCHEDULE PAY SOURCE: Validate Groups ==========
          if (IsPaySourceTypeSchedule(values.paySourceId)) {
            const groupErrors = validateFeeScheduleGroups(values);
            if (groupErrors) {
              errors.ruleFeeScheduleGroupXref = groupErrors;
            }
          }

          // ========== CHARGE PAY SOURCE: Validate Direct Split Payment ==========
          else if (values.useSplitPayment) {
            const splitErrors = validateChargeSplitPayments(values);
            if (splitErrors) {
              errors.ruleSplitPaymentXref = splitErrors;
            }
          }

          // ========== CHARGE PAY SOURCE: Validate Base Rate ==========
          if (!IsPaySourceTypeSchedule(values.paySourceId) && values.useBaseRate) {
            if (!values.baseRate && values.baseRate !== 0) {
              errors.baseRate = 'Base Rate is required';
            } else if (values.baseRate <= 0) {
              errors.baseRate = 'Base Rate must be positive';
            }
          }

          if (!IsPaySourceTypeSchedule(values.paySourceId) && values.applyAt === RULE_APPLY_AT_DATE_OF_SERVICE) {
            if(values.dosMaxRate === '' || values.dosMaxRate === null || values.dosMaxRate === undefined) {
              errors['dosMaxRate'] = intl.formatMessage({
                id: "AUTH.VALIDATION.REQUIRED_FIELD"
              });
            }
            else if (values.dosMaxRate !== null && values.dosMaxRate !== undefined && values.dosMaxRate !== '' && values.dosMaxRate < 0) {
              errors['dosMaxRate'] = "Negative values are not allowed";
            }
          }


          if (!IsPaySourceTypeSchedule(values.paySourceId) && values.useCustomPaymentDates) {
            if(!values.useSplitPayment) {
              const paymentChargeErrors = values.rulePaymentFeeScheduleXRef?.map((entry, index) => {
                const entryError = {};
                let hasError = false;

                if (!entry.payMethodId) {
                  entryError['payMethodId'] = intl.formatMessage({
                    id: "AUTH.VALIDATION.REQUIRED_FIELD"
                  });
                  hasError = true;
                }

                if (entry.payValue === null || entry.payValue === '' || entry.payValue === undefined) {
                  entryError['payValue'] = intl.formatMessage({
                    id: "AUTH.VALIDATION.REQUIRED_FIELD"
                  });
                  hasError = true;
                }

                // Validate payValue is not negative
                if (entry.payValue !== null && entry.payValue !== undefined && entry.payValue !== '' && entry.payValue < 0) {
                  entryError['payValue'] = "Negative values are not allowed";
                  hasError = true;
                }

                if (values.applyAt === RULE_APPLY_AT_DATE_OF_SERVICE) {
                  if(entry.dosMaxRate === '' || entry.dosMaxRate === null || entry.dosMaxRate === undefined) {
                    entryError['dosMaxRate'] = intl.formatMessage({
                      id: "AUTH.VALIDATION.REQUIRED_FIELD"
                    });
                    hasError = true;
                  } 
                  else if (entry.dosMaxRate !== null && entry.dosMaxRate !== undefined && entry.dosMaxRate !== '' && entry.dosMaxRate < 0) {
                    entryError['dosMaxRate'] = "Negative values are not allowed";
                    hasError = true;
                  }
                }
                
                if (entry.dateRange === null || entry.dateRange?.startdate === null || entry.dateRange?.enddate === null || entry.dateRange?.startdate === '' || entry.dateRange?.startdate === undefined || entry.dateRange?.enddate === '' || entry.dateRange?.enddate === undefined) {
                  entryError['dateRange'] = intl.formatMessage({
                    id: "AUTH.VALIDATION.REQUIRED_FIELD"
                  });
                  hasError = true;
                }
                else if(entry.dateRange !== null) {
                  // Check for date range overlaps with other entries
                  if (entry.dateRange.startdate && entry.dateRange.enddate) {
                    const from1 = new Date(entry.dateRange.startdate);
                    const to1 = new Date(entry.dateRange.enddate);

                    for (let j = 0; j < values.rulePaymentFeeScheduleXRef.length; j++) {
                      if (j === index) continue; // Skip self

                      const otherEntry = values.rulePaymentFeeScheduleXRef[j];
                      if (otherEntry.dateRange.startdate && otherEntry.dateRange.enddate) {
                        const from2 = new Date(otherEntry.dateRange.startdate);
                        const to2 = new Date(otherEntry.dateRange.enddate);

                        // Check for overlap: (from1 <= to2) AND (from2 <= to1)
                        if (from1 <= to2 && from2 <= to1) {
                          entryError['dateRange'] = `Date range overlaps with payment ${j + 1}`;
                          hasError = true;
                          break;
                        }
                      }
                    }
                  }
                }
                
                // Validate Anesthesia case
                if (isPayMethodAnesthesia(entry.payMethodId) && entry.useMinutesPerUnit) {
                  if (!entry.minutesPerUnit || entry.minutesPerUnit <= 0) {
                    entryError['minutesPerUnit'] = 'Minutes Per Unit is required and must be greater than 0';
                    hasError = true;
                  }
                }

                if (hasError) {
                  return entryError;
                }

                return false;
              });

              const filteredPaymentChargeErrors = paymentChargeErrors?.filter(value => value && Object.keys(value).length > 0);

              if (filteredPaymentChargeErrors && filteredPaymentChargeErrors.length > 0) {
                errors['rulePaymentFeeScheduleXRef'] = paymentChargeErrors;
              }
            }
          }

          // OLD SPLIT PAYMENT VALIDATION (Deprecated - kept for reference during transition)
          // This validation is for the OLD structure and should eventually be removed
          const splitPaymentsErrors =!values.useSplitPayment ? []: values.ruleSplitPaymentXref.map((paySplit,index) => {
            const payErrors: any = {};

            let hasError = false;
            const errorChecks=["payMethodId","payValue","equator",...(paySplit?.equator==="in_between" ? ["startsAt","endsAt"]: ["value"])]
            const excludedZeroChecks=["payMethodId","payValue","equator"]


            if (
              paySplit?.equator === "in_between" &&
              parseInt(paySplit["endsAt"]) < parseInt(paySplit["startsAt"])
          ) {
              payErrors["endsAt"] =
                  "End Range Must be Greater than start Range";
              hasError = true;
          }
          
          if (!isSelectedPaySourceSchedule(values.paySourceId) && values.useCustomPaymentDates) {
            if (paySplit.dateRange === null || paySplit.dateRange?.startdate === null || paySplit.dateRange?.enddate === null || paySplit.dateRange?.startdate === '' || paySplit.dateRange?.startdate === undefined || paySplit.dateRange?.enddate === '' || paySplit.dateRange?.enddate === undefined) {
              payErrors['dateRange'] = intl.formatMessage({
                id: "AUTH.VALIDATION.REQUIRED_FIELD"
              });
              hasError = true;
            }
            else if(paySplit.dateRange !== null) {
              // Check for date range overlaps with other entries
              if (paySplit.dateRange.startdate && paySplit.dateRange.enddate) {
                const from1 = new Date(paySplit.dateRange.startdate);
                const to1 = new Date(paySplit.dateRange.enddate);

                for (let j = 0; j < values.ruleSplitPaymentXref.length; j++) {
                  if (j === index) continue; // Skip self

                  const otherPaySplit = values.ruleSplitPaymentXref[j];
                  if (otherPaySplit.dateRange.startdate && otherPaySplit.dateRange.enddate) {
                    const from2 = new Date(otherPaySplit.dateRange.startdate);
                    const to2 = new Date(otherPaySplit.dateRange.enddate);

                    // Check for overlap: (from1 <= to2) AND (from2 <= to1)
                    if (from1 <= to2 && from2 <= to1) {
                      payErrors['dateRange'] = `Date range overlaps with payment ${j + 1}`;
                      hasError = true;
                      break;
                    }
                  }
                }
              }
            }
          }

            errorChecks?.forEach((item) => {
              if (!paySplit[item] && paySplit[item]!==0) {
                payErrors[item] = intl.formatMessage({
                  id: "AUTH.VALIDATION.REQUIRED_FIELD"
                });
                hasError = true;
              }

              //applyAt charge ad pay source charge or schedule pay value should be integer not decimal
              if (item === "payValue" && isSelectedPaySourceSchedule(values.paySourceId) && values.applyAt === "Charge") {

                if (!Number.isInteger(paySplit[item])) {
                  payErrors[item] = "Pay Value must be an integer (No decimals allowed)";
                  hasError = true;
                }
              }

              if(excludedZeroChecks.includes(item)===false && paySplit[item]<=0 && !payErrors[item])
              {
                payErrors[item] = "Negative Values and Zero not allowed";
                hasError = true;
              }
              if(item==="payValue" && !payErrors[item] && paySplit[item]!=0 &&  (paySplit[item]<0 || !paySplit[item]))
              {
                 payErrors[item] = "Negative Values are not allowed";
                hasError = true;
              }
            }
            )

            // Validation for Fee Schedule in split payment - check for local OR global based on toggle
            if (isSelectedPaySourceSchedule(values.paySourceId)) {
              const hasLocalFeeSchedule = paySplit.feeScheduleId;
              const hasGlobalFeeSchedule = paySplit.globalFeeScheduleId;
              const hasFeeSchedule = values.useGlobalFeeSchedules ? hasGlobalFeeSchedule : hasLocalFeeSchedule;
              
              if (!hasFeeSchedule) {
                payErrors.feeScheduleId = intl.formatMessage({
                  id: "AUTH.VALIDATION.REQUIRED_FIELD"
                });
                hasError = true;
              }
            }

            // Validation for Rate Label in split payment - required for BOTH local and global fee schedules
            if (isSelectedPaySourceSchedule(values.paySourceId)) {
              if (values.useGlobalFeeSchedules) {
                // Global fee schedule - check globalFeescheduleLabelToRateXRefId
                const hasGlobalFeeSchedule = paySplit.globalFeeScheduleId;
                const hasGlobalRateLabel = paySplit.feescheduleLabelToRateXRefId;
                
                if (hasGlobalFeeSchedule && !hasGlobalRateLabel) {
                  payErrors.feescheduleLabelToRateXRefId = intl.formatMessage({
                    id: "AUTH.VALIDATION.REQUIRED_FIELD"
                  });
                  hasError = true;
                }
              } else {
                // Local fee schedule - check feescheduleLabelToRateXRefId
                const hasLocalFeeSchedule = paySplit.feeScheduleId;
                const hasLocalRateLabel = paySplit.feescheduleLabelToRateXRefId;
                
                if (hasLocalFeeSchedule && !hasLocalRateLabel) {
                  payErrors.feescheduleLabelToRateXRefId = intl.formatMessage({
                    id: "AUTH.VALIDATION.REQUIRED_FIELD"
                  });
                  hasError = true;
                }
              }
            }

            // Validation for Regional Fields in split payment - ONLY for GLOBAL RBRVS fee schedules
            if (values.useGlobalFeeSchedules && paySplit.requiresGlobalConfig && paySplit.globalFeeScheduleId) {
              const regionalErrors = validateRegionalFields(paySplit);
              if (hasRegionalFieldErrors(regionalErrors)) {
                Object.assign(payErrors, regionalErrors);
                hasError = true;
              }
            }

            // Validation for Fee Schedule date overlaps in split payment
            // Only check when pay source is Schedule and fee schedule has dates
            if (isSelectedPaySourceSchedule(values.paySourceId) && paySplit.feeSchedule?.effectiveDate && paySplit.feeSchedule?.expirationDate) {
              const from1 = new Date(paySplit.feeSchedule.effectiveDate);
              const to1 = new Date(paySplit.feeSchedule.expirationDate);

              for (let j = 0; j < values.ruleSplitPaymentXref.length; j++) {
                if (j === index) continue; // Skip self

                const otherEntry = values.ruleSplitPaymentXref[j];
                // Only check if OTHER fee schedule exists and has dates
                if (otherEntry.feeSchedule?.effectiveDate && otherEntry.feeSchedule?.expirationDate) {
                  const from2 = new Date(otherEntry.feeSchedule.effectiveDate);
                  const to2 = new Date(otherEntry.feeSchedule.expirationDate);

                  // Only error if DIFFERENT fee schedules with overlapping dates
                  // Same fee schedule is allowed even with overlapping dates
                  const isDifferentFeeSchedule = paySplit.feeScheduleId !== otherEntry.feeScheduleId;
                  const hasDateOverlap = from1 <= to2 && from2 <= to1;

                  if (isDifferentFeeSchedule && hasDateOverlap) {
                    payErrors['feeScheduleId'] = `Fee schedule date range overlaps with split payment ${j + 1}`;
                    hasError = true;
                    break;
                  }
                }
              }
            }

            for (let i = index - 1; i >= 0; i--) {
              const previous = values.ruleSplitPaymentXref[i];

              const currentFeeScheduleId = paySplit.globalFeeScheduleId || paySplit.feeScheduleId;
              const previousFeeScheduleId = previous.globalFeeScheduleId || previous.feeScheduleId;
              const isSameFeeSchedule = currentFeeScheduleId && previousFeeScheduleId && currentFeeScheduleId === previousFeeScheduleId;

              if (!isSameFeeSchedule) {
                continue; 
              }

              const validationMsg =
                "Duplicate selection criteria not allowed";
                
              // Check for "in_between" duplicates (using startsAt and endsAt)
              if (
                paySplit.equator === "in_between" &&
                previous.equator === "in_between" &&
                parseInt(paySplit.startsAt) === parseInt(previous.startsAt) &&
                parseInt(paySplit.endsAt) === parseInt(previous.endsAt)
              ) {
                payErrors["startsAt"] = validationMsg;
                hasError = true;
                break;
              }
              // Check for "equals" duplicates (based on the value)
              else if (
                paySplit.equator === "equals" &&
                previous.equator === "equals" &&
                parseInt(paySplit.value) === parseInt(previous.value)
              ) {
                payErrors["value"] = validationMsg; // Apply error for 'value'
                hasError = true;
                break;
              }
            }

            if (hasError) {
              return payErrors;
            }


            return false;

          });

          

          // OLD: Skip this old validation - now using new helper functions above
          if (false && splitPaymentsErrors.length > 0) {
            if (
                JSON.stringify(splitPaymentsErrors).split("false")?.length -
                    1 !==
                values.ruleSplitPaymentXref?.length
            ) {
                errors["ruleSplitPaymentXref"] = splitPaymentsErrors;
            }
        }
               const isAnesthesia =
                   payMethods?.find((item) => item?.id == values.paymethodId)
                       ?.name === "Anesthesia";
               const isChargeSource =
                   paySources?.find((item) => item?.id == values.paySourceId)
                       ?.name === "Charge";
               const isApplyAtCharge = values.applyAt === "Charge";
               const isCodeSelectionCodes =
                   values.codeSelectionType === "Codes";
               const isCodeSelectionCodeService =
                   values.codeSelectionType === "Code Service";
               const isMethodCPT =
                   methodTypes?.find((item) => item?.id == values?.methodId)
                       ?.name === "CPT/HCPCS";


               if (isAnesthesia && values.useMinutesPerUnit) {
                 if (!values.minutesPerUnit || values.minutesPerUnit <= 0) {
                   errors.minutesPerUnit = 'Minutes Per Unit is required and must be greater than 0';
                 }
               }

          // OLD PAYMENT FEE SCHEDULE VALIDATION (Deprecated - kept for reference during transition)
          // This validation is for the OLD structure and should eventually be removed
          // Validation for Payment Fee Schedule Array (when Pay Source = Schedule and NOT Split Payment)
          if (false && IsPaySourceTypeSchedule(values.paySourceId) && !values.useSplitPayment) {
            const paymentFeeScheduleErrors = values.rulePaymentFeeScheduleXRef?.map((entry, index) => {
              const entryError = {};
              let hasError = false;

              // Validate required fields - check for local OR global fee schedule based on toggle
              const hasLocalFeeSchedule = entry.feeScheduleId;
              const hasGlobalFeeSchedule = entry.globalFeeScheduleId;
              const hasFeeSchedule = values.useGlobalFeeSchedules ? hasGlobalFeeSchedule : hasLocalFeeSchedule;
              
              if (!hasFeeSchedule) {
                entryError['feeScheduleId'] = intl.formatMessage({
                  id: "AUTH.VALIDATION.REQUIRED_FIELD"
                });
                hasError = true;
              }

              // Validate rate label - required for BOTH local and global fee schedules
              if (values.useGlobalFeeSchedules) {
                // Global fee schedule - check globalFeescheduleLabelToRateXRefId
                const hasGlobalRateLabel = entry.globalFeescheduleLabelToRateXRefId;
                
                if (hasFeeSchedule && !hasGlobalRateLabel) {
                  entryError['feescheduleLabelToRateXRefId'] = intl.formatMessage({
                    id: "AUTH.VALIDATION.REQUIRED_FIELD"
                  });
                  hasError = true;
                }
              } else {
                // Local fee schedule - check feescheduleLabelToRateXRefId
                const hasLocalRateLabel = entry.feescheduleLabelToRateXRefId;
                
                if (hasFeeSchedule && !hasLocalRateLabel) {
                  entryError['feescheduleLabelToRateXRefId'] = intl.formatMessage({
                    id: "AUTH.VALIDATION.REQUIRED_FIELD"
                  });
                  hasError = true;
                }
              }

              if (hasFeeSchedule && !entry.payMethodId) {
                entryError['payMethodId'] = intl.formatMessage({
                  id: "AUTH.VALIDATION.REQUIRED_FIELD"
                });
                hasError = true;
              }

              if (hasFeeSchedule && (entry.payValue === null || entry.payValue === '' || entry.payValue === undefined)) {
                entryError['payValue'] = intl.formatMessage({
                  id: "AUTH.VALIDATION.REQUIRED_FIELD"
                });
                hasError = true;
              }

              // Validate payValue is not negative
              if (entry.payValue !== null && entry.payValue !== undefined && entry.payValue !== '' && entry.payValue < 0) {
                entryError['payValue'] = "Negative values are not allowed";
                hasError = true;
              }

              // Validate DOS Max Rate when Apply At = Date of Service
              if (hasFeeSchedule && values.applyAt === RULE_APPLY_AT_DATE_OF_SERVICE && (entry.dosMaxRate === '' || entry.dosMaxRate === null || entry.dosMaxRate === undefined)) {
                entryError['dosMaxRate'] = intl.formatMessage({
                  id: "AUTH.VALIDATION.REQUIRED_FIELD"
                });
                hasError = true;
              }

              // Validate dosMaxRate is not negative
              if (entry.dosMaxRate !== null && entry.dosMaxRate !== undefined && entry.dosMaxRate !== '' && entry.dosMaxRate < 0) {
                entryError['dosMaxRate'] = "Negative values are not allowed";
                hasError = true;
              }

              // Check for date range overlaps with other entries
              if (entry.feeSchedule?.effectiveDate && entry.feeSchedule?.expirationDate) {
                const from1 = new Date(entry.feeSchedule.effectiveDate);
                const to1 = new Date(entry.feeSchedule.expirationDate);

                for (let j = 0; j < values.rulePaymentFeeScheduleXRef.length; j++) {
                  if (j === index) continue; // Skip self

                  const otherEntry = values.rulePaymentFeeScheduleXRef[j];
                  if (otherEntry.feeSchedule?.effectiveDate && otherEntry.feeSchedule?.expirationDate) {
                    const from2 = new Date(otherEntry.feeSchedule.effectiveDate);
                    const to2 = new Date(otherEntry.feeSchedule.expirationDate);

                    // Check for overlap: (from1 <= to2) AND (from2 <= to1)
                    if (from1 <= to2 && from2 <= to1) {
                      entryError['feeScheduleId'] = `Date range overlaps with payment fee schedule ${j + 1}`;
                      hasError = true;
                      break;
                    }
                  }
                }
              }

              if (hasError) {
                return entryError;
              }

              return false;
            });

            const filteredPaymentFeeScheduleErrors = paymentFeeScheduleErrors?.filter(value => value && Object.keys(value).length > 0);

            if (filteredPaymentFeeScheduleErrors && filteredPaymentFeeScheduleErrors.length > 0) {
              errors['rulePaymentFeeScheduleXRef'] = paymentFeeScheduleErrors;
            }
          }

          // Validate Global Fee Schedule Configuration fields (State, Locality, GPCI)
          // For Code Selection section - ONLY when global RBRVS schedule is selected
          // Guard against showCodeSelectionGlobalConfig being corrupted to a string value
          const shouldValidateCodeSelectionRegional = Boolean(showCodeSelectionGlobalConfig) && 
                                                      values.codeSelectionType === 'Fee Schedule' && 
                                                      values.globalFeeScheduleId;
          
          if (shouldValidateCodeSelectionRegional) {
            const regionalErrors = validateRegionalFields(values);
            Object.assign(errors, regionalErrors);
          }

          // OLD EMPTY ARRAY CHECKS (Deprecated - now handled by new validation helpers)
          // Check if payment array is empty when Pay Source = Schedule
          // BUT: Skip this check if Split Payment is enabled (use ruleSplitPaymentXref instead)
          if (false && IsPaySourceTypeSchedule(values.paySourceId) && !values.useSplitPayment) {
            if (!values.rulePaymentFeeScheduleXRef || values.rulePaymentFeeScheduleXRef.length === 0) {
              errors.rulePaymentFeeScheduleXRef = 'At least one payment fee schedule is required';
            }
          }

          // Check if split payment array is empty when Pay Source = Schedule AND Split Payment is enabled
          if (false && IsPaySourceTypeSchedule(values.paySourceId) && values.useSplitPayment) {
            if (!values.ruleSplitPaymentXref || values.ruleSplitPaymentXref.length === 0) {
              errors.ruleSplitPaymentXref = 'At least one split payment fee schedule is required';
            }
          }

          // For Payment section - validate each payment entry for regional fields
          // ONLY validate regional fields if using GLOBAL fee schedules AND NOT using split payment
          if (values.useGlobalFeeSchedules && !values.useSplitPayment && values.rulePaymentFeeScheduleXRef && values.rulePaymentFeeScheduleXRef.length > 0) {
            const regionalErrors: any[] = [];
            
            values.rulePaymentFeeScheduleXRef.forEach((entry: any, index: number) => {
              // Check if entry has a global fee schedule
              const hasGlobalFeeSchedule = entry.globalFeeScheduleId;
              
              if (entry.requiresGlobalConfig && hasGlobalFeeSchedule) {
                const entryRegionalErrors = validateRegionalFields(entry);
                
                // Only add to errors array if there are actual errors
                if (hasRegionalFieldErrors(entryRegionalErrors)) {
                  regionalErrors[index] = entryRegionalErrors;
                }
              }
            });
            
            // Only add to errors object if there are actual regional errors
            // Merge with existing payment fee schedule errors if they exist
            if (regionalErrors.length > 0 && regionalErrors.some(e => e !== undefined)) {
              const existingErrors = errors['rulePaymentFeeScheduleXRef'];
              if (existingErrors) {
                // Merge with existing errors
                const mergedErrors: any = Array.isArray(existingErrors) ? [...existingErrors] : [];
                regionalErrors.forEach((regionError, idx) => {
                  if (regionError && mergedErrors[idx]) {
                    mergedErrors[idx] = {
                      ...mergedErrors[idx],
                      ...regionError
                    };
                  } else if (regionError) {
                    mergedErrors[idx] = regionError;
                  }
                });
                (errors as any)['rulePaymentFeeScheduleXRef'] = mergedErrors;
              } else {
                (errors as any)['rulePaymentFeeScheduleXRef'] = regionalErrors;
              }
            }
          }

          // Regional validation for split payments is already handled within the main validation loop above (L1182-1190)
          // No need for duplicate validation here

          // Check rate label validation errors from state
          if (Object.keys(rateLabelValidationErrors).length > 0) {
            const rateLabelErrors: any[] = [];
            Object.entries(rateLabelValidationErrors).forEach(([index, hasError]) => {
              if (hasError) {
                rateLabelErrors[Number(index)] = {
                  feescheduleLabelToRateXRefId: 'This rate label has no value'
                };
              }
            });

            if (rateLabelErrors.length > 0) {
              (errors as any).ruleFeeScheduleGroupXref = rateLabelErrors;
            }
          }

          if (Object.keys(rateLabelValidationLesserOfErrors).length > 0) {
            const rateLabelErrors: any[] = [];
            Object.entries(rateLabelValidationLesserOfErrors).forEach(([index, hasError]) => {
              if (hasError) {
                rateLabelErrors[Number(index)] = {
                  feescheduleLabelToRateXRefId: 'This rate label has no value'
                };
              }
            });

            if (rateLabelErrors.length > 0) {
              (errors as any).lesserOfConfiguration = rateLabelErrors;
            }
          }

          if (Object.keys(rateLabelValidationProviderRoleErrors).length > 0) {
            const rateLabelErrors: any[] = [];
            Object.entries(rateLabelValidationProviderRoleErrors).forEach(([index, hasError]) => {
              if (hasError) {
                rateLabelErrors[Number(index)] = {
                  feescheduleLabelToRateXRefId: 'This rate label has no value'
                };
              }
            });

            if (rateLabelErrors.length > 0) {
              (errors as any).providerRolePaymentGroupXref = rateLabelErrors;
            }
          }
          setIsInvalidForm(Object.keys(errors).length > 0);
          return errors;
        }}
        onSubmit={(values, { setStatus, setSubmitting, resetForm }) => {

          if (IsPaySourceTypeSchedule(values.paySourceId)
            && isRuleType(values.ruleTypeId, 'RULE')
            && !values.codeServiceId
            && !isWarnOpen
            && values.codeSelectionType === 'Code Service') {

            setWarnOpen(true)
            return
          }

          let payload = {
            name: values.name,
            ruleTypeId: values.ruleTypeId,
            methodId: values.methodId,
            paymethodId:(!values.useSplitPayment && !values.useCustomPaymentDates) ? null : values.paymethodId,
            payvalue:values?.useSplitPayment ? 0: values.payvalue,
            isPerUnit: values.isPerUnit || false,
            // CODE SELECTION: Determine by globalFeeScheduleId presence
            // If globalFeeScheduleId exists, use global; otherwise use local
            feeScheduleId: (values.codeSelectionType === 'Fee Schedule') && !values.usePaymentFeeSchedules
              ? (values.globalFeeScheduleId ? null : values.feeScheduleId)
              : null,
            // Global Fee Schedule Fields
            // PAYMENT: useGlobalFeeSchedules toggle determines local vs global for payment entries
            useGlobalFeeSchedules: values.useGlobalFeeSchedules || false,
            globalFeeScheduleId: (values.codeSelectionType === 'Fee Schedule') && !values.usePaymentFeeSchedules
              ? values.globalFeeScheduleId
              : null,
            globalFeescheduleLabelToRateXRefId: (values.codeSelectionType === 'Fee Schedule') && !values.usePaymentFeeSchedules
              ? (values.globalFeescheduleLabelToRateXRefId?.id ?? values.globalFeescheduleLabelToRateXRefId ?? null)
              : null,
            // Regional fields: Only send if globalFeeScheduleId is present
            globalFeeScheduleState: (values.globalFeeScheduleId && (values.codeSelectionType === 'Fee Schedule'))&& !values.usePaymentFeeSchedules
              ? values.selectedState
              : null,
            globalFeeScheduleLocality: (values.globalFeeScheduleId && (values.codeSelectionType === 'Fee Schedule')) && !values.usePaymentFeeSchedules
              ? values.selectedLocality
              : null,
            globalFeeScheduleGPCI: (values.globalFeeScheduleId && (values.codeSelectionType === 'Fee Schedule')) && !values.usePaymentFeeSchedules
              ? values.selectedGpci
              : null,
            
            paySourceId: values.paySourceId,
            contractServiceId: serviceId,
            description: values.description,
            usePaidCode: values.usePaidCode,
            payInAddition: values.payInAddition,
            fromDate: values.fromDate,
            toDate: values.toDate,
            isCircuitBreaker: values.isCircuitBreaker,
            lesserOf: values.lesserOf,
            useGlobalFsForLesserOf: values.useGlobalFsForLesserOf,
            codeSelectionType: values.codeSelectionType,
            grouperConfigurationId: values.grouperConfigurationId,
            applyAt: values.applyAt,
            maxRate: values.maxRate,
            threshold: values.threshold,
            precedence: values.precedence,
            useNpiRole: values.useNpiRole,
            useModifiers: values.useModifiers,
            ignoreClaim: values.ignoreClaim,
            ignoreCmsConfiguration: values.ignoreCmsConfiguration,
            ruleSelectionCriteriaXref: values.ruleSelectionCriteriaXref
              .filter(x => x.ruleSelectionCriteriaId !== null || x.equator !== '' || x.value !== '' || x.startsAt !== '' || x.endsAt !== '')
              .map(item => ({
                ruleSelectionCriteriaId: item.ruleSelectionCriteriaId.id,
                equator: item.equator,
                value: (item.equator === 'alpha_between' || item.equator === 'in_between')
                  ? `${item.startsAt}&${item.endsAt}`
                  : item.value
              })),

            isSometimesPay: values.isSometimesPay,
            sometimesPayCodes: values.isSometimesPay ? values.sometimesPayCodes : null,
            isCriteriaOperatorAnd: true,
            // Anesthesia fields - only include if Anesthesia pay method is selected
            useMinutesPerUnit: values.useMinutesPerUnit || false,
            minutesPerUnit: values.useMinutesPerUnit ? (values.minutesPerUnit || 15) : null,
          } as Record<string, any>;

          

          if (values.useModifiers) {
            payload = {
              ...payload,
              ruleToModifierXref: values.ruleToModifierXref
                .filter(x => x.modifierId !== '' || x.payMethodId !== '' || x.value !== '')
                .map(item => ({ ...item, modifierId: item.modifierId?.id }))
            }
          }

          if (isRuleType(values.ruleTypeId, 'RULE') && serviceType === CONTRACTED_SERVICE_OUTPATIENT) {
            payload = {
              ...payload,
              groupIds: selectedGroups,
            }
          }

          if (!isRuleType(values.ruleTypeId, 'DEFAULT')) {
            if (values.codeSelectionType === 'Code Service') {
              payload = {
                ...payload,
                carveoutCodes: '',
                codeServiceId: values.codeServiceId,
              }
            } else {
              payload = {
                ...payload,
                carveoutCodes: values.carveoutCodes,
                codeServiceId: null,
              }
            }
          }

          payload = {
            ...payload,
            useMultiProcedurePercent: values.useMultiProcedurePercent,
            multiProcedurePercentageToRuleXref: values.useMultiProcedurePercent ? values.multiProcedurePercents.filter(x => x.precedenceId !== '' || x.percentage !== '') : [],
            usePaymentFeeSchedules: values.usePaymentFeeSchedules || false,
          }

          if (IsPaySourceTypeSchedule(values.paySourceId)) {
            payload = {
              ...payload,
              considerFsTc: values.considerFsTc
            }
          }

          if (IsPaySourceTypeChargeOrSchedule(values.paySourceId)) {
            const processedNPIRates = values.useNpiRate ? values.ruleToNpirateXref.filter(x => x.npi !== '' || x.rate !== '').map(x=> {
              if(payload.useGlobalFeeSchedules) {
                return {
                  ...x,
                  feescheduleLabelToRateXRefId: null,
                  globalFeescheduleLabelToRateXRefId: x.globalFeescheduleLabelToRateXRefId || null
                };
              } else {
                return {
                  ...x,
                  globalFeescheduleLabelToRateXRefId: null
                };
              }
            }) : [];

            payload = {
              ...payload,
              useNpiRate: values.useNpiRate,
              ruleToNpirateXref: processedNPIRates
            }
          }
          if (values.maxRate) {
            payload = {
              ...payload,
              maxRateValue: values.maxRateValue
            }
          }
          if (values.threshold) {
            payload = {
              ...payload,
              thresholdValue: values.thresholdValue
            }
          }
          if (values.applyAt === RULE_APPLY_AT_DATE_OF_SERVICE) {
            payload = {
              ...payload,
              dosMaxRate: values.dosMaxRate
            }
          } else {
            payload = {
              ...payload,
              useSplitPayment:values?.useSplitPayment,
              useGlobalFeeSchedules: values.useGlobalFeeSchedules || false,
              ruleSplitPaymentXref: (IsPaySourceTypeSchedule(values.paySourceId) && values?.useSplitPayment) ? values?.ruleSplitPaymentXref?.map((item, idx)=> {
                const baseItem = item?.equator==="in_between" ? {...item,value:`${item?.startsAt}&${item?.endsAt}`} : item;
                
                // If using global fee schedules, ensure global fields are included and local fields are null
                if (values.useGlobalFeeSchedules) {
                  return {
                    ...baseItem,
                    globalFeeScheduleId: baseItem.globalFeeScheduleId,
                    // Map feescheduleLabelToRateXRefId to globalFeescheduleLabelToRateXRefId (similar to NPI logic)
                    globalFeescheduleLabelToRateXRefId: baseItem.feescheduleLabelToRateXRefId || baseItem.globalFeescheduleLabelToRateXRefId || null,
                    // Backend expects lowercase 's' in 'schedule' for payment entries
                    globalFeescheduleGPCI: baseItem.selectedGpci || baseItem.globalFeeScheduleGPCI,
                    globalFeescheduleState: baseItem.selectedState || baseItem.globalFeeScheduleState,
                    globalFeescheduleLocality: baseItem.selectedLocality || baseItem.globalFeeScheduleLocality,
                    feeScheduleId: null,
                    feescheduleLabelToRateXRefId: null,
                    isPerUnit: baseItem.isPerUnit || false,
                  };
                } else {
                  // Using local fee schedules
                  return {
                    ...baseItem,
                    feeScheduleId: baseItem.feeScheduleId,
                    feescheduleLabelToRateXRefId: baseItem.feescheduleLabelToRateXRefId,
                    globalFeeScheduleId: null,
                    globalFeescheduleLabelToRateXRefId: null,
                    // Backend expects lowercase 's' in 'schedule' for payment entries
                    globalFeescheduleGPCI: null,
                    globalFeescheduleState: null,
                    globalFeescheduleLocality: null,
                    isPerUnit: baseItem.isPerUnit || false,
                  };
                }
              }) : undefined,
              dosMaxRate: 0
            }
          }

          // ========== PAY SOURCE: SCHEDULE ==========
          // Use ruleFeeScheduleGroupXref for Schedule pay source (regardless of split/non-split or base rate)
          if (IsPaySourceTypeSchedule(values.paySourceId)) {
            payload = {
              ...payload,
              useBaseRate: values.useBaseRate || false,
              baseRate: null,  // Base rate is stored in GROUPS, not on Rule
              useGlobalFeeSchedules: values.useGlobalFeeSchedules || false,
              useSplitPayment: values.useSplitPayment || false,

              // Groups with nested payment OR split data
              ruleFeeScheduleGroupXref: values.ruleFeeScheduleGroupXref?.map((group, index) => {
                const baseGroup = {
                  id: group.id || undefined,
                  baseRate: values.useBaseRate ? group.baseRate : null,  // Base rate per group
                };

                // Add fee schedule fields (local OR global, not both)
                const feeScheduleFields = values.useGlobalFeeSchedules
                  ? {
                      // Global fee schedule
                      globalFeeScheduleId: group.globalFeeScheduleId?.id ?? group.globalFeeScheduleId,
                      globalFeescheduleLabelToRateXRefId: group.globalFeescheduleLabelToRateXRefId?.id
                        ?? group.globalFeescheduleLabelToRateXRefId,
                      globalFeescheduleState: group.selectedState || group.globalFeescheduleState,
                      globalFeescheduleLocality: group.selectedLocality || group.globalFeescheduleLocality,
                      globalFeescheduleGPCI: group.selectedGpci || group.globalFeescheduleGPCI,
                      // Null out local fields
                      feeScheduleId: null,
                      feescheduleLabelToRateXRefId: null,
                    }
                  : {
                      // Local fee schedule
                      feeScheduleId: group.feeScheduleId?.id ?? group.feeScheduleId,
                      feescheduleLabelToRateXRefId: group.feescheduleLabelToRateXRefId?.id
                        ?? group.feescheduleLabelToRateXRefId,
                      // Null out global fields
                      globalFeeScheduleId: null,
                      globalFeescheduleLabelToRateXRefId: null,
                      globalFeescheduleState: null,
                      globalFeescheduleLocality: null,
                      globalFeescheduleGPCI: null,
                    };

                // Add nested payment OR split data based on useSplitPayment flag
                const nestedData = values.useSplitPayment
                  ? {
                      // SPLIT PAYMENT - Nested split array
                      ruleSplitPaymentXRef: group.ruleSplitPaymentXRef?.map(split => ({
                        id: split.id || undefined,
                        payMethodId: split.payMethodId?.id ?? split.payMethodId,
                        payValue: split.payValue,
                        equator: split.equator,
                        value: split.equator === 'in_between'
                          ? `${split.startsAt}&${split.endsAt}`
                          : split.value,
                        feeScheduleXrefId: group.id,  // Link to parent group
                        isPerUnit: split.isPerUnit || false,
                      })) || [],
                      // Empty payment array
                      rulePaymentFeeScheduleXRef: [],
                    }
                  : {
                      // NON-SPLIT PAYMENT - Nested payment array (1 item)
                      rulePaymentFeeScheduleXRef: group.rulePaymentFeeScheduleXRef?.map(payment => ({
                        id: payment.id || undefined,
                        payMethodId: payment.payMethodId?.id ?? payment.payMethodId,
                        payValue: payment.payValue,
                        dosMaxRate: payment.dosMaxRate || null,
                        feeScheduleXrefId: group.id,  // Link to parent group
                        isPerUnit: payment.isPerUnit || false,
                        useMinutesPerUnit: payment.useMinutesPerUnit || false,
                        minutesPerUnit: payment.useMinutesPerUnit ? (payment.minutesPerUnit || null) : null,
                      })) || [],
                      // Empty split array
                      ruleSplitPaymentXRef: [],
                    };

                const customDatesFields = {
                  useCustomDates: group.useCustomDates || false,
                  customStartDate: group.useCustomDates && group.customDateRange?.startdate
                    ? group.customDateRange.startdate
                    : null,
                  customEndDate: group.useCustomDates && group.customDateRange?.enddate
                    ? group.customDateRange.enddate
                    : null,
                };

                return {
                  ...baseGroup,
                  ...feeScheduleFields,
                  ...customDatesFields,
                  ...nestedData,
                };
              }),

              // Null out direct payment arrays (NOT used for Schedule pay source)
              rulePaymentFeeScheduleXRef: undefined,
              ruleSplitPaymentXref: undefined,
            };
          }

          // ========== PAY SOURCE: CHARGE ==========
          // Attach payments/split data directly to Rule (NO groups)
          else {
            payload = {
              ...payload,
              useBaseRate: values.useBaseRate || false,
              baseRate: values.useBaseRate ? values.baseRate : null,  // Base rate on Rule directly
              useGlobalFeeSchedules: false,  // Not applicable for Charge pay source
              useCustomPaymentDates: values.useCustomPaymentDates || false,

              // Payment data directly on Rule
              paymethodId: (!values.useSplitPayment && !values.useCustomPaymentDates) ? values.paymethodId : null,
              payvalue: (!values.useSplitPayment && !values.useCustomPaymentDates) ? values.payvalue : 0,

              // Split payment array (only when useSplitPayment = true)
              ruleSplitPaymentXref: values.useSplitPayment
                ? values.ruleSplitPaymentXref?.map((item, idx) => {
                    const baseItem = item.equator === 'in_between'
                      ? { ...item, value: `${item.startsAt}&${item.endsAt}` }
                      : item;

                    return {
                      id: baseItem.id || undefined,
                      payMethodId: baseItem.payMethodId?.id ?? baseItem.payMethodId,
                      payValue: baseItem.payValue,
                      equator: baseItem.equator,
                      value: baseItem.value,
                      feeScheduleXrefId: null,  // NOT linked to any group
                      effectiveDate: values.useCustomPaymentDates ? (baseItem.dateRange?.startdate || null) : null,
                      expirationDate: values.useCustomPaymentDates ? (baseItem.dateRange?.enddate || null) : null,
                      isPerUnit: baseItem.isPerUnit || false,
                    };
                  })
                : undefined,

              // Null out group-based data (NOT used for Charge pay source)
              ruleFeeScheduleGroupXref: undefined,
              rulePaymentFeeScheduleXRef: (values.useCustomPaymentDates && !values.useSplitPayment) ? values.rulePaymentFeeScheduleXRef?.map(payment => ({
                id: payment.id || undefined,
                payMethodId: payment.payMethodId?.id ?? payment.payMethodId,
                payValue: payment.payValue,
                dosMaxRate: payment.dosMaxRate || null,
                feeScheduleXrefId: null,
                payValuePercentage: payment.payValuePercentage || null,
                
                avgLengthOfStay: (values.isAlosEnabled ? null : (payment.avgLengthOfStay || null)),
                effectiveDate: payment.dateRange?.startdate || null,
                expirationDate: payment.dateRange?.enddate || null,

                useMinutesPerUnit: payment.useMinutesPerUnit || false,
                minutesPerUnit: payment.useMinutesPerUnit ? (payment.minutesPerUnit || 15) : null,
                isPerUnit: payment.isPerUnit || false,
              })) || [] : undefined,
            };
          }

          if (values.paymethodId && isPayMethodPerDiemStopLoss(values.paymethodId)) {
            payload = {
              ...payload,
              payValuePercentage: (!values.useSplitPayment && !values.useCustomPaymentDates) ? values.payValuePercentage || null : null,
              isAlosEnabled: values.isAlosEnabled || false,
              avgLengthOfStay: (!values.useSplitPayment && !values.useCustomPaymentDates) ? (values.isAlosEnabled ? null : (values.avgLengthOfStay || null)) : null,
            };
          }

          if(values?.lesserOf) {
            payload = {
              ...payload,
              useGlobalFsForLesserOf: values.useGlobalFsForLesserOf || false,
              lesserOfConfiguration: values.lesserOfConfiguration?.map((lesserOfConfig, index) => {
                const commonFields = {
                  id: lesserOfConfig.id || undefined,
                  lesserOfType: lesserOfConfig.lesserOfType || null,
                  percentage: lesserOfConfig.percentage || null,
                };

                if(lesserOfConfig.lesserOfType === "FeeSchedule") {
                  const feeScheduleFields = values.useGlobalFsForLesserOf
                  ? {
                      // Global fee schedule
                      globalFeeScheduleId: lesserOfConfig.globalFeeScheduleId?.id ?? lesserOfConfig.globalFeeScheduleId,
                      globalFeescheduleLabelToRateXRefId: lesserOfConfig.globalFeescheduleLabelToRateXRefId?.id
                        ?? lesserOfConfig.globalFeescheduleLabelToRateXRefId,
                      globalFeescheduleState: lesserOfConfig.selectedState || lesserOfConfig.globalFeescheduleState,
                      globalFeescheduleLocality: lesserOfConfig.selectedLocality || lesserOfConfig.globalFeescheduleLocality,
                      globalFeescheduleGPCI: lesserOfConfig.selectedGpci || lesserOfConfig.globalFeescheduleGPCI,
                      // Null out local fields
                      feeScheduleId: null,
                      feescheduleLabelToRateXRefId: null,
                    }
                  : {
                      // Local fee schedule
                      feeScheduleId: lesserOfConfig.feeScheduleId?.id ?? lesserOfConfig.feeScheduleId,
                      feescheduleLabelToRateXRefId: lesserOfConfig.feescheduleLabelToRateXRefId?.id
                        ?? lesserOfConfig.feescheduleLabelToRateXRefId,
                      // Null out global fields
                      globalFeeScheduleId: null,
                      globalFeescheduleLabelToRateXRefId: null,
                      globalFeescheduleState: null,
                      globalFeescheduleLocality: null,
                      globalFeescheduleGPCI: null,
                    };

                  return {
                    ...commonFields,
                    ...feeScheduleFields
                  };
                }

                return {
                  ...commonFields
                };
                
              }),
            };
          }

          if (values.useNpiRole) {
            const filteredProviderRolePaymentGroups = values.providerRolePaymentGroupXref?.filter((group: any) => group.payMethodId); 
            if (filteredProviderRolePaymentGroups?.length > 0) {
              payload = {
                ...payload,
                providerRolePaymentGroupXrefRequest: values.providerRolePaymentGroupXref.map((group: any) => {
                  const commonFields = {
                    id: group.id || undefined,
                    payMethodId: group.payMethodId || null,
                    payValue: group.payValue || null,
                    useMinutesPerUnit: group.useMinutesPerUnit || false,
                    isPerUnit: group.isPerUnit || false,
                    minutesPerUnit: group.useMinutesPerUnit ? (group.minutesPerUnit || 15) : null,
                  };
            
                  const isGlobal = group.useGlobalFeeSchedules === true;
            
                  const feeScheduleFields = isGlobal
                    ? {
                        // GLOBAL fee schedule
                        globalFeeScheduleId: group.globalFeeScheduleId?.id ?? group.globalFeeScheduleId,
                        globalFeeScheduleLabelToRateXRefId:
                          group.globalFeeScheduleLabelToRateXRefId?.id ?? group.globalFeeScheduleLabelToRateXRefId,
                        globalFeeScheduleState: group.selectedState || group.globalFeescheduleState || null,
                        globalFeeScheduleLocality: group.selectedLocality || group.globalFeescheduleLocality || null,
                        globalFeeScheduleGPCI: group.selectedGpci || group.globalFeescheduleGPCI || null,
                        // Null out LOCAL fields
                        feeScheduleId: null,
                        feeScheduleLabelToRateXRefId: null,
                        useGlobalFeeSchedules: true
                      }
                    : {
                        // LOCAL fee schedule
                        feeScheduleId: group.feeScheduleId?.id ?? group.feeScheduleId,
                        feeScheduleLabelToRateXRefId:
                          group.feeScheduleLabelToRateXRefId?.id ?? group.feeScheduleLabelToRateXRefId,
                        // Null out GLOBAL fields
                        globalFeeScheduleId: null,
                        globalFeeScheduleLabelToRateXRefId: null,
                        globalFeeScheduleState: null,
                        globalFeeScheduleLocality: null,
                        globalFeeScheduleGPCI: null,
                        useGlobalFeeSchedules: false
                      };
            
                  // Include providerRolePaymentCriteriaXref only if filled
                  const filledCriteria = (group.providerRolePaymentCriteriaXref || []).filter(
                    (criteria: any) =>
                      criteria.providerRoleSelectionCriteriaId ||
                      criteria.equator ||
                      (criteria.value !== null && criteria.value !== undefined && criteria.value !== '')
                  ).map((item: any) =>
                    (item?.equator === "in_between" || item?.equator === "alpha_between")
                      ? { ...item, value: `${item?.startsAt}&${item?.endsAt}` }
                      : item
                  );
            
                  return {
                    ...commonFields,
                    ...feeScheduleFields,
                    ...(filledCriteria.length > 0 && {
                      providerRolePaymentCriteriaXrefRequest: filledCriteria.map((criteria: any) => ({
                        id: criteria.id || undefined,
                        providerRoleSelectionCriteriaId:
                          criteria.providerRoleSelectionCriteriaId?.id ?? criteria.providerRoleSelectionCriteriaId,
                        //type: criteria.type || null,
                        equator: criteria.equator || null,
                        value: criteria.value || null
                      }))
                    })
                  };
                })
              };
            }
          }

          // Get criteria count for insertion
          const criteriaCount = payload.ruleSelectionCriteriaXref?.length || 0;
          if (mode === 'create' || isCopyRule) {
            
            if (shouldReset) {
              ruleCreate(payload, resetForm);
              setShouldReset(false);
            } else {
              ruleCreate(payload, handleCallback);
            }
          }
          else {
            payload = {
              ...payload,
              id: values.id,
            }
            ruleUpdate(values.id, payload, handleCallback);
          }
          handleClose();
        }}
      >
        {({
          values,
          errors,
          touched,
          handleChange,
          handleBlur,
          handleSubmit,
          setFieldValue,
          setFieldError,
          dirty,
          setValues
        }) => (
          <>
            <UnsavedChangesDialog
                open={unsavedChangesModal.open}
                onCancel={() => setUnsavedChangesModal({ open: false, type: null })}
                onDiscard={() => {
                  setUnsavedChangesModal({ open: false, type: null });
                  if (unsavedChangesModal.type === 'Next') {
                    routesHistory.replace(`/cms/contract/${contractId}/rule/${serviceId}/edit/${nextRuleId}/${directoryId || 'root'}`);
                  } else if (unsavedChangesModal.type === 'Prev') {
                    routesHistory.replace(`/cms/contract/${contractId}/rule/${serviceId}/edit/${prevRuleId}/${directoryId || 'root'}`);
                  }
                }}
                onSave={() => {
                  setSearchAction(unsavedChangesModal.type);
                  handleSubmit();
                  setUnsavedChangesModal({ open: false, type: null });
                }}
            />
            <DrgWatcher
              methodTypes={methodTypes}
              isFeeScheduleDrg={isFeeScheduleDrg}
              isCodeServiceDrg={isCodeServiceDrg}
              isDrgCodeSelectionType={isDrgCodeSelectionType}
              setIsDrgCodeSelectionType={setIsDrgCodeSelectionType}
            />
            <form onSubmit={handleSubmit} noValidate autoComplete="off" className={classes.root}>
              <Helmet title="Contract Management" />
              <Portlet>
                <PortletHeader
                  title={`${isCopyRule ? 'Copy Rule - ' : ''}${contract?.name || ''} (${serviceType || ''})`}
                  showTitle={true}
                  toolbar={
                    <PortletHeaderToolbar>
                      {/* Old Flow for Create Mode */}
                      {!isEdit && !isViewOnly && (
                        <>
                          <BackButton text={dirty ? "Cancel" : "Back"} defaultRoute={`/cms/contract/view/${contractId}`} />
                          <SplitButton
                            className={'ml-3'}
                            isRulesPage={true}
                            options={actions}
                            handleSubmit={handleSubmit}
                            onMenuClick={onMenuClick}
                            disabled={rulesCreatePending || rulesUpdatePending}
                            dimmed={isInvalidForm}
                          />
                        </>
                      )}

                      {/* New Flow for Edit Mode */}
                      {isEdit && !viewOnly && (
                        <>
                          <Box component="span" sx={{ mr: '8px' }}>
                            <BackButton text="Back" defaultRoute={`/cms/contract/view/${contractId}`} />
                          </Box>
                           <Tooltip title={'View Previous Rule'}>
                          <Button 
                            onClick={() => {
                              if (dirty) { setUnsavedChangesModal({ open: true, type: 'Prev' }); } 
                              else { routesHistory.replace(`/cms/contract/${contractId}/rule/${serviceId}/edit/${prevRuleId}/${directoryId || 'root'}`); }
                            }} 
                            disabled={!prevRuleId || rulesUpdatePending} 
                            className={classes.prevNextButtons}
                            startIcon={<ArrowBackIcon />}
                          >
                            Previous
                          </Button>
                          </Tooltip>
                           <Tooltip title={'View Next Rule'}>

                          <Button 
                            onClick={() => {
                              if (dirty) { setUnsavedChangesModal({ open: true, type: 'Next' }); } 
                              else { routesHistory.replace(`/cms/contract/${contractId}/rule/${serviceId}/edit/${nextRuleId}/${directoryId || 'root'}`); }
                            }} 
                            disabled={!nextRuleId || rulesUpdatePending} 
                            
                            className={classes.prevNextButtons}
                            endIcon={<ArrowForwardIcon />}
                          >
                            Next
                          </Button>
                          </Tooltip>

                          <Button
                            variant="contained"
                            color="primary"
                            disabled={rulesCreatePending || rulesUpdatePending || !dirty}
                            className={'ml-2'}
                            onClick={() => {
                              setSearchAction('Save');
                              handleSubmit();
                            }}
                            sx={{
                              borderColor: 'white !important',
                              '&:disabled': {
                                background: '#ccc !important'
                              }
                            }}
                          >
                            Save
                          </Button>
                        </>
                      )}
                      {viewOnly && canAccessCMS === true &&  <Button variant="contained" color="primary" sx={{ ml: "10px" }} onClick={() => setViewOnly(false)}>Edit</Button>}
                      {viewOnly && <Button variant="contained" sx={{
                        background: '#f5f5f5 !important',
                        ml: '10px',
                        color: '#646c9a'

                      }} onClick={() => routesHistory.goBack()}>Back</Button>}

                    </PortletHeaderToolbar>
                  }
                />
                <PortletBody>
                    {isInvalidForm && (
                              <Alert severity="error">
                          
                          Please fill required fields
                          </Alert>
                        
                    )}
                  <Grid container className={`${viewOnly && classes.viewOnly}`}>
                  
                    <Grid item xl={9} lg={10} md={12} sm={12}>
                      <Grid container>
                        <Grid item xs={6}>
                          <TextField
                            required
                            label="Rule Name"
                            name="name"
                            className={classes.textField}
                            margin="normal"
                            onBlur={handleBlur}
                            onChange={handleChange}
                            value={values.name}
                            helperText={touched.name && errors.name}
                            error={Boolean(touched.name && errors.name)}
                          />
                        </Grid>
                        <Grid item xs={6}>
                          <TextField
                            label="Description"
                            name="description"
                            className={classes.textField}
                            margin="normal"
                            onBlur={handleBlur}
                            onChange={handleChange}
                            value={values.description}
                            required
                            helperText={(touched.description && errors.description) ?? 'This description is used in the MRF as additional notes.'}
                            error={Boolean(touched.description && errors.description)}
                          />
                        </Grid>
                        <Grid item xs={6}>
                          <FormControl className={classes.formControl}>
                            <InputLabel htmlFor="role">Rule Type</InputLabel>
                            <Select
                              required
                              value={values.ruleTypeId}
                              onChange={(event) => handleRuleChange(event, handleChange, setFieldValue)}
                              error={Boolean(touched.ruleTypeId && errors.ruleTypeId)}
                              input={<Input id="ruleTypeId" />}
                              inputProps={{
                                name: "ruleTypeId",
                                id: "ruleTypeId"
                              }}
                            >
                              {ruleTypes.map(type => (
                                <MenuItem
                                  key={type.id}
                                  value={type.id}
                                >
                                  {type.name}
                                </MenuItem>
                              ))}
                            </Select>
                            <FormHelperText error>{touched.ruleTypeId && errors.ruleTypeId}</FormHelperText>
                          </FormControl>
                        </Grid>
                        <Grid item xs={6}>
                          <FormControl className={classes.formControl}>
                            <InputLabel htmlFor="paySourceId">Pay Source</InputLabel>
                            <Select
                              disabled={isRuleType(values.ruleTypeId, 'DEFAULT') || isPayMethodPerDiemStopLoss(values.paymethodId)}
                              value={values.paySourceId}
                              onChange={(e)=>{
                                if (!isSelectedPaySourceCharge(e.target.value)) {
                                  setValues(prev => ({
                                    ...prev,

                                    // ruleSplitPaymentXref:[paySplit],
                                    useSplitPayment:false,

                                    paySourceId : e.target.value,
                                    usePaymentFeeSchedules: (isSelectedPaySourceSchedule(e.target.value) && prev.codeSelectionType === 'Fee Schedule') ? true : false,
                                    // payvalue: null,
                                    // paymethodId: null
                                  }))
                                }
                                else if(isSelectedPaySourceCharge(e.target.value)){
                                  let codeSelection = values.codeSelectionType;
                                  if(codeSelection === "Grouper") {
                                    codeSelection = "Codes";
                                  }
                                  setValues(prev => ({
                                    ...prev,
                                    usePaymentFeeSchedules:false,
                                    // rulePaymentFeeScheduleXRef: def_rulePaymentFeeScheduleXRef,
                                    paySourceId : e.target.value,
                                    codeSelectionType: codeSelection,
                                  }));
                                  
                                  resetSplitFlow(setFieldValue);
                                  
                                  setFieldValue("codeSelectionType", codeSelection);
                                }
                                setFieldValue("paySourceId", e.target.value);
                              }}
                              error={Boolean(touched.paySourceId && errors.paySourceId)}
                              input={<Input id="paySourceId" />}
                              inputProps={{
                                name: "paySourceId",
                                id: "paySourceId"
                              }}
                            >
                              {paySources.map(paySource => (
                                <MenuItem
                                  key={paySource.id}
                                  value={paySource.id}
                                >
                                  {paySource.name}
                                </MenuItem>
                              ))}
                            </Select>
                            <FormHelperText error>{touched.paySourceId && errors.paySourceId}</FormHelperText>
                          </FormControl>
                        </Grid>
                        <Grid item xs={12}>
                          {isEdit && (
                            <>
                              <Button
                                variant="contained"
                                color="primary"
                                sx={{ ml: 1, mt: 1 }}
                                onClick={handleOpenNotes}
                              >
                                View Notes ({notesCount || 0})
                              </Button>

                              <Button
                                variant="contained"
                                color="primary"
                                sx={{ ml: 1, mt: 1 }}
                                onClick={() => setAuditLogsOpen(true)}
                                >
                                  Audit Logs View
                              </Button>
                            </>
                            )}
                        </Grid>
                        <Grid item xs={12}>
                          <FormControl disabled={isPayMethodStopLoass(values.paymethodId) || isPayMethodPerDiemStopLoss(values.paymethodId) || (values.useCustomPaymentDates && hasAnyStopLossPayMethod(values)) || (values.codeSelectionType === "Grouper")} component="fieldset" className={classes.formToggle}>
                            <FormLabel component="legend">Apply rule at level:</FormLabel>
                            <RadioGroup
                              aria-label="applyAt"
                              name="applyAt"
                              value={values.applyAt}
                              onChange={handleApplyAtChange(setFieldValue)}
                              row
                            >
                              <FormControlLabel value="Charge" control={<Radio />} label="Charge" />
                              <FormControlLabel value="Rule" control={<Radio />} label="Rule" />
                              <FormControlLabel value="Claim" control={<Radio />} label="Claim" />
                              {(serviceType === CONTRACTED_SERVICE_OUTPATIENT || serviceType === CONTRACTED_SERVICE_PROFESSIONAL) &&
                                <FormControlLabel value={RULE_APPLY_AT_DATE_OF_SERVICE} control={<Radio />} label="Date of Service" />
                              }
                            </RadioGroup>
                          </FormControl>
                        </Grid>
                        <Grid item xs={12} className="mt-3">
                          <Card>
                            <Card.Header as="h5">Code Selection</Card.Header>
                            <Card.Body>
                              <Card.Subtitle className="mb-2 text-muted">codes can be defined as code service, feeschedule or listed down in Codes textarea</Card.Subtitle>
                              <Grid container>
                                <Grid item xs={12}>
                                  {renderValidationMessage()}
                                </Grid>
                                <Grid item xs={12}>
                                  <FormControl component="fieldset" className={classes.formToggleCard}>
                                    <RadioGroup
                                      aria-label="codeSelectionType"
                                      name="codeSelectionType"
                                      value={values.codeSelectionType}
                                      onChange={handleCodeSelectionChange(setFieldValue, values)}
                                      row
                                    >
                                      <FormControlLabel disabled={isRuleType(values.ruleTypeId, 'DEFAULT')} value="Code Service" control={<Radio />} label="Code Service" />
                                      <FormControlLabel disabled={isRuleType(values.ruleTypeId, 'DEFAULT')} value="Fee Schedule" control={<Radio />} label="Fee Schedule" />
                                      <FormControlLabel disabled={isRuleType(values.ruleTypeId, 'DEFAULT')} value="Codes" control={<Radio />} label="Codes" />
                                      <FormControlLabel disabled={isRuleType(values.ruleTypeId, 'DEFAULT') || !IsPaySourceTypeSchedule(values.paySourceId)} value="Grouper" control={<Radio />} label="Grouper" />
                                    </RadioGroup>
                                  </FormControl>
                                </Grid>
                                {IsPaySourceTypeSchedule(values.paySourceId) && values.codeSelectionType === 'Fee Schedule' && (
                                  <Grid item xs={12}>
                                    <FormControlLabel
                                      className={classes.switchFormControl}
                                      control={
                                        <Switch
                                          name="usePaymentFeeSchedules"
                                          color="primary"
                                          checked={values.usePaymentFeeSchedules || false}
                                          onChange={(e) => {
                                            const checked = e.target.checked;
                                            setValues(prev => ({
                                              ...prev,
                                              usePaymentFeeSchedules: checked,
                                              feeScheduleId: null,
                                              feeScheduleName: '',
                                              feescheduleLabelToRateXRefId: null,
                                              feeSchedule: null,
                                              globalFeeScheduleId: null,
                                              globalFeescheduleLabelToRateXRefId: null,
                                              selectedState: '',
                                              selectedLocality: '',
                                              selectedGpci: '',
                                            }));
                                          }}
                                          onBlur={handleBlur}
                                          value={values.usePaymentFeeSchedules}
                                        />
                                      }
                                      label="Use Payment Fee Schedules"
                                    />
                                    <span className={classes.helpClass}>
                                      {hoverColumn('When enabled, payment fee schedules will be used for both code selection and payment calculation')}
                                    </span>
                                  </Grid>
                                )}
                                
                                {isRuleType(values.ruleTypeId, 'DEFAULT') || values.codeSelectionType === 'Code Service' && (
                                  <Grid item xs={4}>
                                    <FormControl className={classes.formControl}>
                                      <InputLabel htmlFor="codeServiceId">Service</InputLabel>
                                      <Select
                                        value={values.codeServiceId}
                                        onChange={serviceChangeHandler(setFieldValue)}
                                        error={Boolean(touched.codeServiceId && errors.codeServiceId)}
                                        input={<Input id="codeServiceId" />}
                                        inputProps={{
                                          name: "codeServiceId",
                                          id: "codeServiceId"
                                        }}
                                      >
                                        <MenuItem
                                          value='none'
                                        >
                                          None
                                        </MenuItem>
                                        {codeServices.map(codeService => (
                                          <MenuItem
                                            key={codeService.id}
                                            value={codeService.id}
                                          >
                                            {codeService.name}
                                          </MenuItem>
                                        ))}
                                      </Select>
                                      <FormHelperText error>{touched.codeServiceId && errors.codeServiceId}</FormHelperText>
                                    </FormControl>
                                  </Grid>
                                )}
                                {values.codeSelectionType === 'Codes' &&
                                  // !isRuleType(values.ruleTypeId, 'DEFAULT')) &&
                                  (
                                    <Grid item xs={4}>
                                      <FormControl className={classes.formControl}>
                                        <InputLabel htmlFor="methodId">Method Type</InputLabel>
                                        <Select
                                          value={values.methodId}
                                          onChange={(e) => {
                                            handleChange(e);
                                            handleCarveoutCodeBlur();
                                        }}
                                          error={Boolean(touched.methodId && errors.methodId)}
                                          input={<Input id="methodId" />}
                                          inputProps={{
                                            name: "methodId",
                                            id: "methodId"
                                          }}
                                        >
                                          {methodTypes.filter(mt => !isRuleType(values.ruleTypeId, 'DEFAULT') ? mt.name !== 'ALL' : true).map(methodType => (
                                            <MenuItem
                                              key={methodType.id}
                                              value={methodType.id}
                                            >
                                              {methodType.name}
                                            </MenuItem>
                                          ))}
                                        </Select>
                                        <FormHelperText error>{touched.methodId && errors.methodId}</FormHelperText>
                                      </FormControl>
                                    </Grid>
                                  )}

                                {values.codeSelectionType === 'Fee Schedule' && !values.usePaymentFeeSchedules && (
                                  <Grid item xs={12} >
                                    <Box display='flex' alignItems='center' sx={{minWidth: '100%', gap: 2}}>
                                      <Box sx={{flexShrink: 0, minWidth: '90px', width: 'auto'}}>
                                        <FormControl className={classes.formControl} >
                                          <InputLabel className={`MuiInputLabel-shrink ${classes.feeScheduleLabel}`}>Fee Schedule</InputLabel>
                                          <Box marginTop={1}>
                                            <span
                                              onMouseEnter={(event) => {
                                                handleHoverFeeSchedule(event.currentTarget, values?.feeScheduleId || values?.globalFeeScheduleId, values?.feeSchedule || values?.globalFeeSchedule, values?.globalFeeScheduleId, values?.globalFeeScheduleId ? { state: values?.selectedState, gpci: values?.selectedGpci, locality: values?.selectedLocality } : null)}}
                                              onMouseLeave={popoverLeave}
                                              onClick={popoverLeave}
                                              style={{ display: 'inline-block' }}
                                            >
                                              <FeeScheduleSelection
                                                value={(values?.globalFeeScheduleId || values?.feeScheduleId) ? values?.feeScheduleName : ''}
                                                defaultValue='Search Fee Schedule'
                                                feeScheduleType={(() => {
                                                  const type = values?.globalFeeScheduleId ? 'global' : (values?.feeScheduleId ? 'local' : undefined);
                                                  return type;
                                                })()}
                                                handleSetFeeSchedule={(rowData)=>{
                                                  // CODE SELECTION: Determine if this is a global or local schedule based on the schedule itself
                                                  // isGlobal can be boolean true, number 1, string "1", or truthy value
                                                  const isGlobalSchedule = Boolean(rowData.isGlobal);
                                                  
                                                  if (isGlobalSchedule) {
                                                    setFieldValue("globalFeeScheduleId", rowData?.id);
                                                    setFieldValue("feeScheduleId", null);
                                                    setFieldValue("globalFeescheduleLabelToRateXRefId", null);
                                                    setFieldValue("feescheduleLabelToRateXRefId", null);
                                                  } else {
                                                    setFieldValue("feeScheduleId", rowData?.id);
                                                    setFieldValue("globalFeeScheduleId", null);
                                                    setFieldValue("feescheduleLabelToRateXRefId", null);
                                                    setFieldValue("globalFeescheduleLabelToRateXRefId", null);
                                                  }
                                                  
                                                  setFieldValue("feeScheduleName", rowData?.name);
                                                  setFieldValue("ruleToNpirateXref", values.ruleToNpirateXref?.map(x=> ({...x, feescheduleLabelToRateXRefId: null})) ?? []);
                                                  setFieldValue("ruleToNpiroleXref", values.ruleToNpiroleXref?.map(x=> ({...x, feescheduleLabelToRateXRefId: null})) ?? []);
                                                  
                                                  // Reset regional fields when changing fee schedule
                                                  setFieldValue("selectedState", null);
                                                  setFieldValue("selectedLocality", null);
                                                  setFieldValue("selectedGpci", null);
                                                  setFieldValue("globalFeeScheduleState", null);
                                                  setFieldValue("globalFeeScheduleLocality", null);
                                                  setFieldValue("globalFeeScheduleGPCI", null);
                                                  
                                                  getFeeScheduleLabels(rowData?.id, getFeescheduleLabelsCallback, null, setFieldValue, isGlobalSchedule);

                                                  // Check if this is a global RBRVS schedule - show config fields if so
                                                  if (isGlobalSchedule) {
                                                    // For global schedules, check if it's RBRVS
                                                    // isRBRVS can be boolean true, number 1, string "1", or truthy value
                                                    const isRBRVSSchedule = Boolean(rowData.isRBRVS);
                                                    const isDMEFEESCHEDULE = rowData?.name?.toLowerCase()==="dme";
                                                    const isAnesthesiaSchedule = rowData?.name?.toLowerCase() === 'anesthesia';

                                                    safeSetShowCodeSelectionGlobalConfig(isRBRVSSchedule || isDMEFEESCHEDULE || isAnesthesiaSchedule);
                                                  } else {
                                                    // Local fee schedule - don't show global config
                                                    safeSetShowCodeSelectionGlobalConfig(false);
                                                  }

                                                  if (getFeeSchedule && !isGlobalSchedule) {
                                                    getFeeSchedule(rowData?.id, (feeSchedule) => {
                                                      setFieldValue("feeSchedule", feeSchedule);
                                                    });
                                                  } else {
                                                    setFieldValue("feeSchedule", null);
                                                  }
                                                }}
                                              />
                                            </span>
                                          </Box>
                                          <FormHelperText error>{touched.feeScheduleId && errors.feeScheduleId}</FormHelperText>
                                        </FormControl>
                                      </Box>
                                      {values?.feeSchedule?.effectiveDate && values?.feeSchedule?.expirationDate && (
                                        <Box sx={{ color: 'text.secondary', marginTop: '28px' }}>
                                          <Typography variant="body2" style={{ whiteSpace: 'nowrap', fontSize: '0.875rem' }}>
                                            {new Date(values.feeSchedule.effectiveDate).toLocaleDateString()} - {new Date(values.feeSchedule.expirationDate).toLocaleDateString()}
                                          </Typography>
                                        </Box>
                                      )}
                                    </Box>
                                  </Grid>
                                )}

                                {/* Global Fee Schedule Fields - Show when Global Fee Schedule is selected */}
                                {/* CODE SELECTION: Show regional fields if globalFeeScheduleId exists and payment fee schedules toggle is OFF */}
                                {showCodeSelectionGlobalConfig && values.codeSelectionType === 'Fee Schedule' && values.globalFeeScheduleId && !values.usePaymentFeeSchedules && (
                                  <Grid item xs={12}>
                                    <GlobalFeeScheduleFields
                                      scheduleId={values.globalFeeScheduleId}
                                      isRBRVS={showCodeSelectionGlobalConfig}
                                      values={{
                                        selectedRateType: values.selectedRateType || null,
                                        selectedState: values.selectedState || null,
                                        selectedLocality: values.selectedLocality || null,
                                        selectedGpci: values.selectedGpci || null,
                                        isDME: values?.feeScheduleName?.toLowerCase() === "dme",
                                        isAnesthesia: values?.feeScheduleName?.toLowerCase() === 'anesthesia'
                                      }}
                                      onChange={(field, value) => {
                                        // Guard against wrong field names
                                        const validFields = ['selectedState', 'selectedLocality', 'selectedGpci', 'selectedRateType'];
                                        if (validFields.includes(field)) {
                                          setFieldValue(field, value);
                                        }
                                      }}
                                      errors={{
                                        selectedRateType: (touched.selectedRateType && errors.selectedRateType) ? String(errors.selectedRateType) : '',
                                        selectedState: (touched.selectedState && errors.selectedState) ? String(errors.selectedState) : '',
                                        selectedLocality: (touched.selectedLocality && errors.selectedLocality) ? String(errors.selectedLocality) : '',
                                        selectedGpci: (touched.selectedGpci && errors.selectedGpci) ? String(errors.selectedGpci) : ''
                                      }}
                                    />
                                  </Grid>
                                )}

                                {values.codeSelectionType === 'Grouper' && (
                                  <Grid item xs={4}>
                                    <FormControl className={classes.formControl}>
                                      <InputLabel htmlFor="grouperConfigurationId">Method Type</InputLabel>
                                      <Select
                                        value={values.grouperConfigurationId}
                                        onChange={handleChange}
                                        error={Boolean(touched.grouperConfigurationId && errors.grouperConfigurationId)}
                                        input={<Input id="grouperConfigurationId" />}
                                        inputProps={{
                                          name: "grouperConfigurationId",
                                          id: "grouperConfigurationId"
                                        }}
                                      >
                                        {grouperConfigs.map(grouperConfig => (
                                          <MenuItem
                                            key={grouperConfig.id}
                                            value={grouperConfig.id}
                                          >
                                            {grouperConfig.name}
                                          </MenuItem>
                                        ))}
                                      </Select>
                                      <FormHelperText error>{touched.grouperConfigurationId && errors.grouperConfigurationId}</FormHelperText>
                                    </FormControl>
                                  </Grid>
                                )}

                                {((isRuleType(values.ruleTypeId, 'CARVEOUT')
                                  || isRuleType(values.ruleTypeId, 'RULE'))
                                  && (values.codeSelectionType === 'Codes')) && (
                                    <>
                                      <Grid item xs={8}>
                                        <FormLabel className={`${classes.codesLabel} ${(Boolean(touched.carveoutCodes && errors.carveoutCodes)) ? classes.errorColor : ''}`} disabled={values.isCodeService === 'true'} id="carveout-codes">Codes *
                                          <IconButton onClick={handleCodesOpen} className="p-1" size="large">
                                            <ZoomInIcon />
                                          </IconButton>
                                        </FormLabel>
                                        <TextareaAutosize
                                          aria-labelledby="carveout-codes"
                                          minRows='3'
                                          maxRows='8'
                                          // placeholder="Codes"
                                          name="carveoutCodes"
                                          className={`${classes.textareaAutosize} ${(Boolean(touched.carveoutCodes && errors.carveoutCodes)) ? classes.textAreaError : ''}`}
                                          onBlur={() => handleCarveoutCodeBlur()}
                                          onChange={handleCarveoutCodeChange(setFieldValue)}
                                          value={values.carveoutCodes}
                                        />
                                        <p className={`${(Boolean(touched.carveoutCodes && errors.carveoutCodes)) && classes.errorColor} ${classes.helperText} MuiFormHelperText-root`}>e.g A1000-A1099; 100; 101; 70001-70010; 90001;</p>
                                      </Grid>
                                      {rulesValidateCodesPending && (
                                        <Grid item xs={1} className='pt-4'>
                                          <CircularProgress size={25} />
                                        </Grid>
                                      )}
                                    </>
                                  )}
                              </Grid>
                            </Card.Body>
                          </Card>
                        </Grid>
                        <Grid item xs={12} className="mt-5">
                         <Card>
                         <Card.Header  style={{display:"flex",justifyContent:"space-between"}}>

                          <Typography variant="h6">{totalPaymentsSplit>1 ? "Payments":'Payment'} </Typography>

                         <Box sx={{ display: 'flex', gap: 2 }}>
                         {/* Base Rate Toggle - Disabled when not all pay methods are Per Unit */}
                         <FormGroup>
                 <Tooltip title={!areAllPayMethodsPerUnit(values) ? 'Base Rate is only available when all pay methods are Per Unit' : 'Toggle to use Base Rate'}>
                     <Typography component="div" sx={{ width: 'fit-content' }}>
                         <Grid component="label" container alignItems="center" spacing={0} className='mb-0'>
                             <Grid item>
                                 <Switch
                                     checked={values?.useBaseRate}
                                     disabled={!areAllPayMethodsPerUnit(values) || values.codeSelectionType === "Grouper"}
                                     onChange={(e) => {
                                      const checked = e.target.checked;
                                      setFieldValue('useBaseRate', checked);
                                    }}
                                     name="useBaseRate" />
                             </Grid>
                             <Grid item>Use Base Rate</Grid>
                         </Grid>
                     </Typography>
                 </Tooltip>
             </FormGroup>

                         {shouldSplitPayments(values) && <FormGroup>
                 <Tooltip title='Toggle to Split Payments'>
                     <Typography component="div" sx={{ width: 'fit-content' }}>
                         <Grid component="label" container alignItems="center" spacing={0} className='mb-0'>
                             <Grid item>
                                 <Switch
                                     // disabled={pending}
                                     checked={values?.useSplitPayment}
                                     onChange={(e) => {
                                      const checked = e.target.checked;
                                      setValues(prev => {
                                        // Reset groups when turning on split payment
                                        const resetGroups = checked ? [{
                                          id: null,
                                          feeScheduleId: null,
                                          feeScheduleName: '',
                                          feeSchedule: null,
                                          feescheduleLabelToRateXRefId: null,
                                          globalFeeScheduleId: null,
                                          globalFeescheduleLabelToRateXRefId: null,
                                          globalFeeSchedule: null,
                                          globalFeescheduleState: null,
                                          globalFeescheduleLocality: null,
                                          globalFeescheduleGPCI: null,
                                          baseRate: null,
                                          rateLabels: [],
                                          requiresGlobalConfig: false,
                                          selectedState: null,
                                          selectedLocality: null,
                                          selectedGpci: null,
                                          rulePaymentFeeScheduleXRef: [{
                                            id: null,
                                            payMethodId: null,
                                            payValue: null,
                                            dosMaxRate: null,
                                            feeScheduleXrefId: null
                                          }],
                                          ruleSplitPaymentXRef: [{
                                            id: null,
                                            payMethodId: null,
                                            payValue: null,
                                            equator: '',
                                            value: '',
                                            startsAt: '',
                                            endsAt: '',
                                            feeScheduleXrefId: null
                                          }]
                                        }] : prev.ruleFeeScheduleGroupXref;

                                        return {
                                          ...prev,
                                          useSplitPayment: checked,
                                          ruleFeeScheduleGroupXref: resetGroups,
                                          ruleSplitPaymentXref: checked ? prev.ruleSplitPaymentXref : [paySplit],
                                        };
                                      });

                                    }}
                                     name="useSplitPayment" />
                             </Grid>
                             <Grid item>Split Payment Based on Units</Grid>
                         </Grid>
                     </Typography>
                 </Tooltip>
             </FormGroup>}
             {isPayMethodPerDiemStopLoss(values.paymethodId) && isDrgCodeSelectionType && <FormGroup>
                 <Tooltip title={values?.isAlosEnabled ? 'Toggle to use custom ALOS' : 'Toggle to use Drg Based ALOS'}>
                     <Typography component="div" sx={{ width: 'fit-content' }}>
                         <Grid component="label" container alignItems="center" spacing={0} className='mb-0'>
                             <Grid item>
                                 <Switch
                                     checked={values?.isAlosEnabled}
                                     onChange={(e) => {
                                      const checked = e.target.checked;
                                      setValues(prev => ({
                                        ...prev,
                                        isAlosEnabled: checked,
                                      }));
                                    }}
                                     name="isAlosEnabled" />
                             </Grid>
                             <Grid item>Enable ALOS from Drg</Grid>
                         </Grid>
                     </Typography>
                 </Tooltip>
             </FormGroup>}
             </Box>
                          </Card.Header>

                          <Card.Body style={{ marginTop: 32 }}>
                          {!isSelectedPaySourceSchedule(values.paySourceId) && <Tooltip title={'Toggle to use custom dates for multiple charge payments'}>
                             <Typography component="div" sx={{ width: 'fit-content' }}>
                                <Grid component="label" container alignItems="center" spacing={0} className='mb-0'>
                                    <Grid item>
                                        <Switch
                                            checked={values?.useCustomPaymentDates}
                                            onChange={(e) => {
                                              const checked = e.target.checked;
                                              setValues(prev => ({
                                                ...prev,
                                                useCustomPaymentDates: checked,
                                              }));
                                            }}
                                            name="useCustomPaymentDates" />
                                    </Grid>
                                    <Grid item>Custom Dates</Grid>
                                </Grid>
                            </Typography>
                            </Tooltip>}
                            {/* Base Rate Field - Only show for Charge scenarios when useBaseRate is enabled */}
                            {values.useBaseRate && !isSelectedPaySourceSchedule(values.paySourceId) && (
                              <Grid container spacing={2} sx={{ mb: 3 }}>
                                <Grid item xs={4}>
                                  <TextField
                                    fullWidth
                                    size="small"
                                    label="Base Rate *"
                                    name="baseRate"
                                    type="number"
                                    value={values.baseRate ?? ''}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    error={Boolean(touched.baseRate && errors.baseRate)}
                                    helperText={touched.baseRate && errors.baseRate ? errors.baseRate : ''}
                                  />
                                </Grid>
                              </Grid>
                            )}

                            {/* Schedule Pay Source: Always use Fee Schedule Groups (base rate field is conditional inside) */}
                            {isSelectedPaySourceSchedule(values.paySourceId) ? (
                              <RuleFeeScheduleGroupArray
                                values={values}
                                setFieldValue={setFieldValue}
                                setFieldError={setFieldError}
                                errors={errors}
                                touched={touched}
                                handleChange={handleChange}
                                handleBlur={handleBlur}
                                payMethods={payMethods}
                                useSplitPayment={values.useSplitPayment}
                                useBaseRate={values.useBaseRate || false}
                                useGlobalFeeSchedules={values.useGlobalFeeSchedules || false}
                                getFeeScheduleLabels={getFeeScheduleLabels}
                                getFeeSchedule={getFeeSchedule}
                                handleHoverFeeSchedule={handleHoverFeeSchedule}
                                popoverLeave={popoverLeave}
                                handleGroupPayMethodChange={handleGroupPayMethodChange}
                                rateLabelValidationErrors={rateLabelValidationErrors}
                                setRateLabelValidationErrors={setRateLabelValidationErrors}
                                 areAllPayMethodsPerUnit={areAllPayMethodsPerUnit}
                                isPayMethodFlatRate={isPayMethodFlatRate}
                                isPayMethodPercentage={isPayMethodPercentage}
                              />
                            ) 
                            : (!isSelectedPaySourceSchedule(values.paySourceId) && values.useCustomPaymentDates === true && values.useSplitPayment === false) ? (
                              <RulePaymentFeeScheduleArray
                                values={values}
                                setFieldValue={setFieldValue}
                                errors={errors}
                                touched={touched}
                                handleChange={handleChange}
                                handleBlur={handleBlur}
                                payMethods={filteredPayMethods}
                                classes={classes}
                                isPayMethodPerDiemStopLoss={isPayMethodPerDiemStopLoss}
                                isPayMethodAnesthesia={isPayMethodAnesthesia}
                                isPayMethodFlatRate={isPayMethodFlatRate}
                                areAllPayMethodsPerUnit={areAllPayMethodsPerUnit}
                              />
                            )
                            : (
                              /* Charge Pay Source: Use existing RulesSplitFieldArray */
                              <RulesSplitFieldArray
                                bindArrayPush={bindArrayPush}
                                values={values}
                                RULE_APPLY_AT_DATE_OF_SERVICE={RULE_APPLY_AT_DATE_OF_SERVICE}
                                shouldSplitPayments={shouldSplitPayments}
                                touched={touched}
                                onClickAddSplitPaymentSection={() => onClickAddSplitPaymentSection(values)}
                                setFieldValue={setFieldValue}
                                handlePayMethodChange={handlePayMethodChange}
                                ruleCriteria={ruleCriteria}
                                handleBlur={handleBlur}
                                classes={classes}
                                errors={errors}
                                handleChange={handleChange}
                                payMethods={values.useSplitPayment ? (filteredPayMethods?.filter((item) => validPayMethodsInSplitCase.includes(item?.name)) || []) : filteredPayMethods}
                                feeSchedules={feeSchedules}
                                feeScheduleLabels={feeScheduleLabels}
                                getFeeScheduleLabels={getFeeScheduleLabels}
                                getFeeSchedule={getFeeSchedule}
                                handleHoverFeeSchedule={handleHoverFeeSchedule}
                                popoverLeave={popoverLeave}
                                paySources={paySources}
                                isPayMethodPerDiemStopLoss={isPayMethodPerDiemStopLoss}
                                isPayMethodFlatRate={isPayMethodFlatRate}
                                useCustomPaymentDates={values.useCustomPaymentDates}
                                areAllPayMethodsPerUnit={areAllPayMethodsPerUnit}
                              />
                            )}
                          </Card.Body>
                       </Card>

                        </Grid>
                        <Grid item xs={12} className="mt-5">
                          <Card>
                            <Card.Header as="h5">Service Date Range (Optional)</Card.Header>
                            <Card.Body>
                              <Grid container>
                                <Grid item xs={4}>
                                  <TextField
                                    type="date"
                                    label="From Date"
                                    name="fromDate"
                                    className={classes.textField}
                                    margin="normal"
                                    onBlur={handleBlur}
                                    onChange={handleChange}
                                    value={values?.fromDate || ''}
                                    helperText={touched.fromDate && errors.fromDate}
                                    error={Boolean(touched.fromDate && errors.fromDate)}
                                    InputLabelProps={{
                                      shrink: true,
                                    }}
                                  />
                                </Grid>
                                <Grid item xs={4}>
                                  <TextField
                                    type="date"
                                    label="To Date"
                                    name="toDate"
                                    className={classes.textField}
                                    margin="normal"
                                    onBlur={handleBlur}
                                    onChange={handleChange}
                                    value={values?.toDate || ''}
                                    helperText={touched.toDate && errors.toDate}
                                    error={Boolean(touched.toDate && errors.toDate)}
                                    InputLabelProps={{
                                      shrink: true,
                                    }}
                                  />
                                </Grid>
                              </Grid>

                            </Card.Body>
                          </Card>
                        </Grid>
                       { !values.useSplitPayment &&  <Grid item xs={12} className="mt-5">
                          <Card>
                            <Card.Header as="h5">Selection Criteria (Optional)</Card.Header>
                            <Card.Body>
                              <RuleSelectionCriteriaFieldArray
                                values={values}
                                ruleCriteria={ruleCriteria}
                                handleChange={handleChange}
                                handleBlur={handleBlur}
                                touched={touched}
                                errors={errors}
                                setFieldValue={setFieldValue}
                                npiRoles={npiRoles}
                                dischargeStatusCodes={dischargeStatusCodes}
                              />
                            </Card.Body>
                          </Card>
                        </Grid>}
                        <Grid item xs={12} className="mt-5">
                          <Card>
                            <Card.Header as="h5">Configurations (Optional)</Card.Header>
                            <Card.Body>
                              <Grid container>
                                <Grid item xs={12}>
                                  <FormControlLabel
                                    className={classes.switchFormControl}
                                    control={
                                      <Switch
                                        checked={values.payInAddition}
                                        onBlur={handleBlur}
                                        onChange={handleChange}
                                        name="payInAddition"
                                      />
                                    }
                                    label="Pay In Addition"
                                  />
                                  <span className={classes.helpClass}>
                                    {hoverColumn('Pays in addition to per diem, case rates, and other circuit breakers')}
                                  </span>
                                </Grid>
                                <Grid item xs={12}>
                                  <FormControlLabel
                                    className={classes.switchFormControl}
                                    control={
                                      <Switch
                                        checked={values.isCircuitBreaker}
                                        onBlur={handleBlur}
                                        onChange={handleChange}
                                        name="isCircuitBreaker"
                                      />
                                    }
                                    label="Circuit Breaker"
                                  />
                                  <span className={classes.helpClass}>
                                    {hoverColumn('Stops processing of other rules when hit')}
                                  </span>
                                </Grid>
                                <Grid item xs={12}>
                                  <FormControlLabel
                                    className={classes.switchFormControl}
                                    control={
                                      <Switch
                                        checked={values.lesserOf}
                                        onBlur={handleBlur}
                                        onChange={handleChange}
                                        name="lesserOf"
                                      />
                                    }
                                    label="Lesser Of"
                                  />
                                  <span className={classes.helpClass}>
                                    {hoverColumn('Applies the lesser of charge amount or fee schedule')}
                                  </span>
                                </Grid>
                                <Grid item xs={12}>
                                  <Grid container>
                                    <Grid item xl={3} lg={4} xs={4}>
                                      <FormControlLabel
                                        className={classes.switchFormControl}
                                        control={
                                          <Switch
                                            checked={values.maxRate}
                                            onBlur={handleBlur}
                                            onChange={handleChange}
                                            name="maxRate"
                                          />
                                        }
                                        label="Max Rate"
                                      />
                                      <span className={classes.helpClass}>
                                        {hoverColumn('Maximum dollar amount allowed either by Charge Line, rule, or claim level')}
                                      </span>
                                    </Grid>
                                    <Grid item xl={9} lg={8} xs={8}>
                                      {(values.maxRate) &&
                                        <Grid item xs={6}>
                                          <TextField
                                            required
                                            // label="Max Rate Value"
                                            name="maxRateValue"
                                            className={`ml-0 ${classes.textFieldInline}`}
                                            margin="normal"
                                            onBlur={handleBlur}
                                            onChange={handleChange}
                                            value={values.maxRateValue}
                                            helperText={touched.maxRateValue && errors.maxRateValue}
                                            error={Boolean(touched.maxRateValue && errors.maxRateValue)}
                                            InputProps={{
                                              startAdornment: <InputAdornment position="start">$</InputAdornment>,
                                            }}
                                          />
                                        </Grid>
                                      }
                                    </Grid>
                                  </Grid>
                                </Grid>
                                <Grid item xs={12}>
                                  <Grid container>
                                    <Grid item xl={3} lg={4} xs={4}>
                                      <FormControlLabel
                                        className={classes.switchFormControl}
                                        control={
                                          <Switch
                                            disabled={isPayMethod2ndDollar(values.paymethodId)}
                                            checked={values.threshold}
                                            onBlur={handleBlur}
                                            onChange={handleChange}
                                            name="threshold"
                                          />
                                        }
                                        label="Threshold"
                                      />
                                      <span className={classes.helpClass}>
                                        {hoverColumn('Dollar amount that must be met in order for rule to trigger')}
                                      </span>
                                    </Grid>
                                    <Grid item xs={5}>
                                      {values.threshold &&
                                        <Grid item xl={9} lg={8} xs={8}>
                                          <TextField
                                            required
                                            // label="Threshold Value"
                                            name="thresholdValue"
                                            className={`ml-0 ${classes.textFieldInline}`}
                                            margin="normal"
                                            onBlur={handleBlur}
                                            onChange={handleChange}
                                            value={values.thresholdValue}
                                            helperText={touched.thresholdValue && errors.thresholdValue}
                                            error={Boolean(touched.thresholdValue && errors.thresholdValue)}
                                            InputProps={{
                                              startAdornment: <InputAdornment position="start">$</InputAdornment>,
                                            }}
                                          />
                                        </Grid>
                                      }
                                    </Grid>
                                  </Grid>

                                </Grid>
                                {IsPaySourceTypeSchedule(values.paySourceId) && (
                                  <>
                                    <Grid item xs={12}>
                                      <FormControlLabel
                                        className={classes.switchFormControl}
                                        control={
                                          <Switch
                                            name="usePaidCode"
                                            color="primary"
                                            checked={values.usePaidCode}
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                            value={values.usePaidCode}
                                          />
                                        }
                                        label="Paid Code"
                                      />
                                      <span className={classes.helpClass}>
                                        {hoverColumn('Grouping by APC or other paid codes in fee schedule to only be paid once per code')}
                                      </span>
                                    </Grid>

                                    <Grid item xs={12}>
                                      <Grid item xs={4}>
                                        <FormControlLabel
                                          className={classes.switchFormControl}
                                          control={
                                            <Switch
                                              name="considerFsTc"
                                              color="primary"
                                              checked={values.considerFsTc}
                                              onChange={handleChange}
                                              onBlur={handleBlur}
                                              value={values.considerFsTc}
                                            />
                                          }
                                          label="Consider Fee Schedule Technical Component"
                                        />
                                      </Grid>
                                    </Grid>
                                  </>
                                )}
                                <Grid item xs={12}>
                                  <Grid container>
                                    <Grid item xl={3} lg={4} xs={4}>
                                      <FormControlLabel
                                        className={classes.switchFormControl}
                                        control={
                                          <Switch
                                            name="useMultiProcedurePercent"
                                            color="primary"
                                            checked={values.useMultiProcedurePercent}
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                            value={values.useMultiProcedurePercent}
                                          />
                                        }
                                        label="Multiprocedure Percents"
                                      />
                                      <span className={classes.helpClass}>
                                        {hoverColumn('Tiered rates for multiple procedures based on CPT or Paid Codes')}
                                      </span>
                                    </Grid>
                                    {values.useMultiProcedurePercent && (
                                      <Grid item xl={9} lg={8} xs={8}>
                                        <RuleMultiPrecidenceFieldArray
                                          values={values}
                                          multiprocPrecedences={multiprocPrecedences}
                                          handleChange={handleChange}
                                          handleBlur={handleBlur}
                                          touched={touched}
                                          errors={errors}
                                        />
                                      </Grid>
                                    )}
                                  </Grid>
                                </Grid>
                                {IsPaySourceTypeChargeOrSchedule(values.paySourceId) && <>
                                  <Grid item xs={12}>
                                    <Grid container>
                                      <Grid item xl={3} lg={4} xs={4}>
                                        <FormControlLabel
                                          className={classes.switchFormControl}
                                          control={
                                            <Switch
                                              name="useNpiRate"
                                              color="primary"
                                              checked={values.useNpiRate}
                                              onChange={handleChange}
                                              onBlur={handleBlur}
                                              value={values.useNpiRate}
                                            />
                                          }
                                          label="Billing NPI"
                                        />
                                      </Grid>
                                      {values.useNpiRate && (
                                        <Grid item xl={9} lg={8} xs={8}>
                                          <RuleNPIRateFieldArray
                                            isPaySourceTypeSchedule={IsPaySourceType(values.paySourceId, 'Schedule')}
                                            values={values}
                                            payMethod={payMethods.find((item)=>item?.id===values.paymethodId)}
                                            handleChange={handleChange}
                                            setFieldValue={setFieldValue}
                                            handleBlur={handleBlur}
                                            touched={touched}
                                            errors={errors}
                                            getFeeScheduleLabels={getFeeScheduleLabels}
                                            handleFeeScheduleLabelToRateXrefChange = {handleFeeScheduleLabelToRateXrefChange}
                                          />
                                        </Grid>
                                      )}
                                    </Grid>
                                  </Grid>
                                </>}

                                <Grid item xs={12}>
                                  <Grid container>
                                    <Grid item xl={3} lg={4} xs={4}>
                                      <FormControlLabel
                                        className={classes.switchFormControl}
                                        control={
                                          <Switch
                                            name="isSometimesPay"
                                            color="primary"
                                            checked={values.isSometimesPay}
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                            value={values.isSometimesPay}
                                          />
                                        }
                                        label="Sometimes Pay"
                                      />
                                    </Grid>
                                    {values.isSometimesPay && (
                                      <>
                                        <Grid item xl={8} lg={8} xs={8}>
                                          <SomeTimesPayCodes values={values} errors={errors} touched={touched} setFieldValue={setFieldValue} />
                                        </Grid>
                                      </>
                                    )}
                                  </Grid>
                                </Grid>

                                {serviceType === CONTRACTED_SERVICE_PROFESSIONAL &&
                                  <Grid item xs={12}>
                                    <Grid container>
                                      <Grid item xl={3} lg={4} xs={4}>
                                        <FormControlLabel
                                          className={classes.switchFormControl}
                                          control={
                                            <Switch
                                              name="useNpiRole"
                                              color="primary"
                                              checked={values.useNpiRole}
                                              onChange={handleChange}
                                              onBlur={handleBlur}
                                              value={values.useNpiRole}
                                              disabled={values.codeSelectionType === "Grouper"}
                                            />
                                          }
                                          label="Provider Role"
                                        />
                                      </Grid>
                                    </Grid>
                                  </Grid>
                                }
                                <Grid item xs={12}>
                                  <Grid container>
                                    <Grid item xl={3} lg={4} xs={4}>
                                      <FormControlLabel
                                        className={classes.switchFormControl}
                                        control={
                                          <Switch
                                            name="useModifiers"
                                            color="primary"
                                            checked={values.useModifiers}
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                            value={values.useModifiers}
                                          />
                                        }
                                        label="Modifiers"
                                      />
                                    </Grid>
                                    {values.useModifiers && (
                                      <Grid item xl={9} lg={8} xs={8}>
                                        <RuleModifierFieldArray
                                          values={values}
                                          handleChange={handleChange}
                                          handleBlur={handleBlur}
                                          setFieldValue={setFieldValue}
                                          touched={touched}
                                          errors={errors}
                                          isPayMethodMultiProcedure={isPayMethodMultiProcedure}

                                          modifiers={modifiers}
                                          modifiersPayMethods={modifiersPayMethods}
                                        />
                                      </Grid>
                                    )}
                                  </Grid>
                                </Grid>
                                <Grid item xs={12}>
                                  <Grid item xs={4}>
                                    <FormControlLabel
                                      className={classes.switchFormControl}
                                      control={
                                        <Switch
                                          name="ignoreClaim"
                                          color="primary"
                                          checked={values.ignoreClaim}
                                          onChange={handleChange}
                                          onBlur={handleBlur}
                                          value={values.ignoreClaim}
                                        />
                                      }
                                      label="Ignore Claim"
                                    />
                                    <span className={classes.helpClass}>
                                      {hoverColumn('Ignores claim if Rule matches')}
                                    </span>
                                  </Grid>
                                </Grid>
                                <Grid item xs={12}>
                                  <Grid item xs={4}>
                                    <FormControlLabel
                                      className={classes.switchFormControl}
                                      control={
                                        <Switch
                                          name="ignoreCmsConfiguration"
                                          color="primary"
                                          checked={values.ignoreCmsConfiguration}
                                          onChange={handleChange}
                                          onBlur={handleBlur}
                                          value={values.ignoreCmsConfiguration}
                                        />
                                      }
                                      label="Ignore CMS Configuration"
                                    />
                                  </Grid>
                                </Grid>

                              </Grid>
                            </Card.Body>
                          </Card>
                        </Grid>
                        {values.lesserOf &&  
                        <Grid item xs={12} className="mt-5">
                          <Card>
                            <Card.Header style={{display:"flex",justifyContent:"space-between"}}>
                              <Typography variant="h6">{'Lesser Of'} </Typography>
                              <Box sx={{ display: 'flex', gap: 2 }}>
                              <FormGroup>
                                  <Tooltip title={'Use Global Fee schedules for Lesser of'}>
                                      <Typography component="div" sx={{ width: 'fit-content' }}>
                                          <Grid component="label" container alignItems="center" spacing={0} className='mb-0'>
                                              <Grid item>
                                                  <Switch
                                                      disabled={handleLesserOfGlobalFSDisable(values?.useGlobalFsForLesserOf, setFieldValue, values.lesserOfConfiguration)}
                                                      checked={values?.useGlobalFsForLesserOf}
                                                      onChange={(e) => {
                                                        const checked = e.target.checked;

                                                        const clearedConfiguration = values.lesserOfConfiguration?.map(config => {
                                                          if (config.lesserOfType === 'FeeSchedule') {
                                                            return {
                                                              ...config,
                                                              // Clear local fee schedule fields
                                                              feeScheduleId: null,
                                                              feeScheduleName: '',
                                                              feescheduleLabelToRateXRefId: null,
                                                              feeSchedule: null,
                                                              // Clear global fee schedule fields
                                                              globalFeeScheduleId: null,
                                                              globalFeeSchedule: null,
                                                              globalFeescheduleLabelToRateXRefId: null,
                                                              // Clear regional fields (RBRVS)
                                                              selectedState: null,
                                                              selectedLocality: null,
                                                              selectedGpci: null,
                                                              globalFeescheduleState: null,
                                                              globalFeescheduleLocality: null,
                                                              globalFeescheduleGPCI: null,
                                                              requiresGlobalConfig: false,
                                                              // Clear rate labels
                                                              rateLabels: []
                                                            };
                                                          }
                                                          return config;
                                                        });

                                                        setFieldValue('useGlobalFsForLesserOf', checked);
                                                        setFieldValue('lesserOfConfiguration', clearedConfiguration);
                                                      }}
                                                      name="useGlobalFsForLesserOf" />
                                              </Grid>
                                              <Grid item>Use Global Fee Schedules</Grid>
                                          </Grid>
                                      </Typography>
                                  </Tooltip>
                              </FormGroup>
                              </Box>
                            </Card.Header>
                            <Card.Body>
                              <RuleLesserOfFieldArray
                                values={values}
                                handleChange={handleChange}
                                handleBlur={handleBlur}
                                touched={touched}
                                errors={errors}
                                setFieldValue={setFieldValue}
                                setFieldError={setFieldError}
                                getFeeSchedule={getFeeSchedule}
                                getFeeScheduleLabels={getFeeScheduleLabels}
                                handleHoverFeeSchedule={handleHoverFeeSchedule}
                                popoverLeave={popoverLeave}
                                rateLabelValidationErrors={rateLabelValidationLesserOfErrors}
                                setRateLabelValidationErrors={setRateLabelValidationLesserOfErrors}
                              />
                            </Card.Body>
                          </Card>
                        </Grid>}                        
                        {values.useNpiRole &&  <Grid item xs={12} className="mt-5">
                          <Card>
                            <Card.Header as="h5">Provider Role</Card.Header>
                            <Card.Body>
                              <RuleProviderRolePaymentGroupFieldArray
                                values={values}
                                setFieldValue={setFieldValue}
                                setFieldError={setFieldError}
                                errors={errors}
                                touched={touched}
                                handleChange={handleChange}
                                handleBlur={handleBlur}
                                payMethods={IsPaySourceTypeSchedule(values.paySourceId) ? payMethods?.filter((method: any) => method.name === PAY_METHOD_PERCENTAGE || method.name === PAY_METHOD_PER_UNIT || method.name?.toLowerCase().includes('multiplier') || method.name === PAY_METHOD_ANESTHESIA) : filteredPayMethods}
                                getFeeScheduleLabels={getFeeScheduleLabels}
                                getFeeSchedule={getFeeSchedule}
                                handleHoverFeeSchedule={handleHoverFeeSchedule}
                                popoverLeave={popoverLeave}
                                rateLabelValidationErrors={rateLabelValidationProviderRoleErrors}
                                setRateLabelValidationErrors={setRateLabelValidationProviderRoleErrors}
                                classes={classes}
                                IsPaySourceTypeSchedule={IsPaySourceTypeSchedule}
                                providerRoleCriteria={providerRoleCriteria}
                                npiRoles={npiRoles}
                                 areAllPayMethodsPerUnit={areAllPayMethodsPerUnit}
                                 isPayMethodFlatRate={isPayMethodFlatRate}
                                isPayMethodAnesthesia={isPayMethodAnesthesia}
                                isPayMethodPercentage={isPayMethodPercentage}
                              />
                            </Card.Body>
                          </Card>
                        </Grid>}
                      </Grid>
                    </Grid>
                    {/* {isRuleType(values.ruleTypeId, 'RULE') && serviceType === CONTRACTED_SERVICE_PROFESSIONAL && (
                    <Grid item xs={5} >
                      <div className={classes.ruleGroups}>
                        <h4>Groups</h4>
                        <GroupsTreeView ruleId={ruleId === 'new' ? 0 : ruleId} selected={false} selectedGroups={selectedGroups} handleGroupSelect={handleGroupSelect} />
                      </div>
                    </Grid>
                  )} */}
                  </Grid>
                </PortletBody>
              </Portlet>
              <NotesDialog
                open={notesOpen}
                onClose={() => setNotesOpen(false)}
                title={values?.name || 'Rule'}
                noteType={NoteType.Rule}
                notes={notes || []}
                totalCount={notesCount || 0}
                page={notesPage}
                rowsPerPage={NOTES_PAGE_SIZE}
                loading={notesListPending}
                saving={notesSavePending}
                exporting={notesExportPending}
                entityId={ruleId}
                onRefresh={handleRefreshNotes}
                onPageChange={handleNotesPageChange}
                sortModel={notesSortModel}
                onSortModelChange={handleNotesSortModelChange}
                onSaveInline={handleSaveNotes}
                onExport={handleExportNotes}
              />
              <EntityAuditLogsDialog
                  open={auditLogsOpen}
                  onClose={() => setAuditLogsOpen(false)}
                  title={values?.name || 'Rule'}
                  itemType="RULE"
                  entityId={ruleId}
              />
            </form>
            <Dialog open={isWarnOpen} onClose={handleClose}>
              <DialogTitle>
                Warning!
              </DialogTitle>
              <DialogContent>
                <DialogContentText>
                  Saving a rule with no code service selected will cause all items in the fee schedule to be considered
                </DialogContentText>
              </DialogContent>
              <DialogActions>
                <Button onClick={handleClose} color="primary" type='button'>
                  Let me Add one
                </Button>
                <Button
                  onClick={handleSubmit as any}
                  className="text-danger"
                  type='button'
                >
                  Continue
                </Button>
              </DialogActions>
            </Dialog>
            <CodesEditDialog
              open={isCodesOpen}
              codes={values.carveoutCodes}
              methodId={values.methodId}
              handleClose={handleCodesClose}
              handleCodesChange={handleCodesChange(setFieldValue)}
            />
            {/* Hover Popover for Fee Schedule quick link (Code Selection) */}
            {hoverFeeScheduleId && (
              <DetailsPopover
                isPopoverOpen={isPopoverOpen}
                anchorEl={anchorEl}
                title={hoverFeeSchedule?.name || 'Fee Schedule'}
                items={[
                  ...(hoverFeeSchedule?.global ? [{}]:[{
                    label: "Effective Date",
                    data: hoverFeeSchedule?.effectiveDate ? formatDate(hoverFeeSchedule.effectiveDate) : ''
                  }]),
                  ...(hoverFeeSchedule?.global ? [{}]:[{
                    label: "Expiration Date",
                    data: hoverFeeSchedule?.expirationDate ? formatDate(hoverFeeSchedule.expirationDate) : ''
                  }]),
                  {
                    type: "LINK",
                    label:hoverFeeSchedule?.global ? "Go to Global Fee Schedule" : "Go to Fee Schedule",
                    data: `/cms/${hoverFeeSchedule?.global ? 'global-feeschedules' : 'feeschedules'}/view/${hoverFeeSchedule?.id ?? hoverFeeScheduleId}${hoverFeeSchedule?.global ? '?preset=true' : ''}`,
                    onClick: hoverFeeSchedule?.global ? () => {
                      const filters = [
                        hoverFeeScheduleRegionalFilters?.state ? { field: 'state', equator: 'equals', value: hoverFeeScheduleRegionalFilters.state } : null,
                        hoverFeeScheduleRegionalFilters?.gpci ? { field: 'gpci', equator: 'equals', value: hoverFeeScheduleRegionalFilters.gpci } : null,
                        hoverFeeScheduleRegionalFilters?.locality ? { field: 'locality', equator: 'equals', value: hoverFeeScheduleRegionalFilters.locality } : null,
                      ].filter(Boolean);
                      setGlobalConfigsFilters(filters);
                    } : undefined
                  }
                ]}
                actions={{
                  popoverLeave,
                  paperEnter
                }}
                pending={getFeeScheduleItemsPending}
              />

            )}

          </>
        )}
      </Formik>
    </Loadable>
  </>);
}